var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _use, _use2, _path316, _path317, _path318, _circle, _path319, _path320, _path321, _path322, _path323, _circle2, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-bo",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    d: "M0 0h512v341.3H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "M0 0h512v170.7H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M307.8 224.8 203.3 329.2a97.8 97.8 0 0 0-1.4-1c.4-.5 104-103.8 104.5-104.5a7.4 7.4 0 0 1 1.4 1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M314.3 218.2c-.4.7-1.5 2.6-1 4l-2.1-1.6c.5 1 .4 1.5-.2 1.9-.3.4-1.5.3-2.2.2a6 6 0 0 0 2.6 1l2 .1c-.6.3-2.3.9-3.4 1-.6.2-1.7.3-2.2 0-.6.6-2-.4-1.3-1-.3-.4-.3-.9-.4-1.5 0-.8 0-2 .7-3.2 0 .6.3 1.2.5 1.8.2.5.7 1 1.2 1.5-.3-.5-.5-1.3 0-1.9.6-.5 1.4-.5 2.2-.2l-2-1.4c.8 0 3.5-1 4.4-1.6a67 67 0 0 0 5.2-4 57.6 57.6 0 0 0-4 4.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m327.5 237.6-134 75.7-1-1.3c.5-.4 133.2-75.2 134-75.7a6.3 6.3 0 0 1 1 1.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M335.9 232.8c-.6.6-2.3 2.2-2.3 3.6-.7-.7-1-1.2-1.6-2 .3 1 0 1.6-.7 1.8-.4.3-1.5 0-2.2-.3.6.6 1.2 1.2 2.2 1.6l1.9.5c-.7.2-2.5.3-3.7.2-.5 0-1.6-.2-2-.6-.8.5-1.8-.8-1-1.3-.2-.3 0-.8.1-1.4.2-.8.7-2 1.7-3a8.3 8.3 0 0 0 0 1.9c0 .6.3 1.1.6 1.7-.1-.5 0-1.3.7-1.7.7-.5 1.5-.3 2.1.2l-1.5-1.8c.8.2 3.7-.2 4.7-.5s4.4-1.8 6.4-2.7a65 65 0 0 0-5.4 3.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m316 232-120.4 90.9-1.2-1.2 120.5-90.9a6.3 6.3 0 0 1 1.2 1.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M323.6 226.2c-.5.7-2 2.4-1.7 3.9l-1.8-1.8c.4 1 .1 1.5-.5 1.8-.4.4-1.5.2-2.2 0 .7.5 1.4 1 2.4 1.3l2 .3c-.7.3-2.4.6-3.6.7-.6 0-1.7 0-2.1-.4-.7.5-2-.6-1.2-1.2-.2-.3-.2-.8-.1-1.5 0-.7.4-2 1.2-3a8.4 8.4 0 0 0 .2 1.8c.1.6.5 1 1 1.6-.3-.5-.3-1.3.3-1.8.7-.5 1.5-.4 2.1 0l-1.7-1.7c.8.1 3.6-.6 4.6-1 1-.4 4-2.2 5.8-3.4a61.8 61.8 0 0 0-4.7 4.4z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m204.2 224.8 104.5 104.4a97.8 97.8 0 0 1 1.4-1L205.5 223.6l-1.3 1z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M197.7 218.2c.3.7 1.5 2.6 1 4l2.1-1.6c-.5 1-.4 1.5.2 1.9.3.4 1.5.3 2.2.2a6 6 0 0 1-2.6 1l-2 .1c.6.3 2.3.9 3.4 1 .6.2 1.7.3 2.2 0 .6.6 2-.4 1.4-1 .2-.4.3-.9.3-1.5a6.2 6.2 0 0 0-.7-3.2 8.5 8.5 0 0 1-.5 1.8c-.2.5-.7 1-1.2 1.5.3-.5.5-1.3 0-1.9-.6-.5-1.4-.5-2.2-.2l2-1.4c-.8 0-3.5-1-4.4-1.6a67 67 0 0 1-5.2-4c1.3 1.4 3.6 4.1 4 4.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m184.5 237.6 134 75.7 1-1.3c-.5-.4-133.2-75.2-134-75.7l-1 1.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M176.1 232.8c.6.6 2.3 2.2 2.4 3.6l1.4-2c-.2 1 .2 1.6.8 1.8.4.3 1.5 0 2.2-.3a5.4 5.4 0 0 1-2.2 1.6l-1.9.5c.7.2 2.5.3 3.6.2.6 0 1.7-.2 2.1-.6.8.5 1.8-.8 1-1.3.2-.3 0-.8-.1-1.4a6.8 6.8 0 0 0-1.7-3v1.9c0 .6-.3 1.1-.6 1.7.1-.5 0-1.3-.7-1.7-.7-.5-1.5-.3-2.1.2l1.4-1.8c-.7.2-3.6-.2-4.6-.5-1-.3-4.4-1.8-6.4-2.7a65 65 0 0 1 5.4 3.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m196 232 120.4 90.9 1.2-1.2-120.5-90.9-1.2 1.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M188.4 226.2c.5.7 2 2.4 1.7 3.9l1.8-1.8c-.4 1-.1 1.5.5 1.8.4.4 1.5.2 2.2 0-.6.5-1.4 1-2.4 1.3l-2 .3c.7.3 2.4.6 3.6.7.6 0 1.7 0 2.1-.4.7.5 2-.6 1.2-1.2.2-.3.2-.8.1-1.5 0-.7-.4-2-1.2-3a8.4 8.4 0 0 1-.2 1.8c-.1.6-.5 1-1 1.6.3-.5.3-1.3-.3-1.8-.7-.5-1.5-.4-2.2 0l1.8-1.7c-.8.1-3.6-.6-4.6-1a70.7 70.7 0 0 1-5.8-3.4l4.7 4.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#00e519",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M234.8 302.4a40.8 40.8 0 0 1 17.8-4c-8.5 6.5-17 6.8-17.8 4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe533",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M234.8 302.4c.8 2.8 9.3 2.5 17.8-3.9a67 67 0 0 1-17.7 3.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M234.8 302.4c.8 2.8 9.3 2.5 17.8-3.9a67 67 0 0 1-17.7 3.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M234.8 302.3a44 44 0 0 1 17.8-3.9c-8.4 6.5-17 6.7-17.8 4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m285.4 234.8-27.2 55.8c-1.3 1.1-2.4-.3-2.8-.2-1.7 1.9-3.9 2.3-4.4 2.7-1.9 2.5-.8 4.6-.7 4.8 1.4 2-1.7 3.8-1.5 4.4-.7 1-3 .8-3.4 2l-5 10c-.8.5-4 6.5-4 6.5-2.2 0-10.9-5.6-11-5.5 4.8-7.8 16.5-19.7 16.2-20.5 3.3-5.6 8.5-11.6 10.8-11.5 3.2-1.7 4.8-6 4.1-7 2.5-.1 3.8-1.6 4-1.7l20-40c1.7-.6 1.5.1 2 1 0 0 1-1.2 1-1.4 1-.4 1.9.2 1.9.6z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M286.4 222.7c-.5 1 .3 1 .6 1.2l1.2.3c1.3 0 2 .7 2 1.2l-32 65.2c-1.3 1.1-2.6-.2-3 0l21.9-44.7 10.6-20-2.9-1.3c-.9-.2-1.2-.8-.8-1.7l13.4-23-10.7 22.3-.3.5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M286.4 222.7c-.5 1 .3 1 .6 1.2l1.2.3c1.3 0 2 .7 2 1.2l-32 65.2c-1.3 1.1-2.6-.2-3 0l21.9-44.7 10.6-20-2.9-1.3c-.9-.2-1.2-.8-.8-1.7l13.4-23-10.7 22.3-.3.5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M244 290.6c-3-.1-4.8 2.2-2.8 5m1.5-2.5c-1.1.6-1.9-.4-1.9-.4m16.3-14c-1.7 6-4.7 10-5.3 11.2-2.3 2.4-4.2 7.7-3.8 8.7l-8.7 14.2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M258.1 290.9c-1.4-.5-6.1-4.9-10.7-4.1-3.5 4-5.6 8.2-6.2 8.8a60 60 0 0 0 8.1 5.8c.7-.5 1-1.7 1-1.7 1-1-.1-1.8-.1-1.8.1-2.7 2-4.5 4-4.6 2.4-.2 1.7-.4 2-.4 1.1-.6 1.9-2 1.9-2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M258.1 290.9c-1.4-.5-6.1-4.9-10.7-4.1-3.5 4-5.6 8.2-6.2 8.8a60 60 0 0 0 8.1 5.8c.7-.5 1-1.7 1-1.7 1-1-.1-1.8-.1-1.8.1-2.7 2-4.5 4-4.6 2.4-.2 1.7-.4 2-.4 1.1-.6 1.9-2 1.9-2z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M253.4 291c-2.1 0-4.3 1-5 2.8l5-2.8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M253.4 291c-2.1 0-4.3 1-5 2.8m-3.9.7c.2.4.8.7 1.3.5.5-.2.8-.7.6-1.1-.2-.5-.8-.7-1.3-.5-.5.2-.8.6-.6 1.1zm2.7-3.6c.2.4.8.6 1.3.5.5-.2.8-.7.6-1.2-.2-.4-.8-.6-1.3-.4-.5.1-.8.6-.6 1z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M283 241.2c.8-.3 1.2-1.3.8-2.2l-5-1.8s-.6.1-1 .8c-.6.7.1 1.3.1 1.3l5.1 1.9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M283 241.2c.8-.3 1.2-1.3.8-2.2l-5-1.8s-.6.1-1 .8c-.6.7.1 1.3.1 1.3l5.1 1.9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#00e519",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M228.8 305.1c4.2-2.9 16-4.6 17.7-4.1-8.3 6.6-16.9 7-17.7 4.1z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe533",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M228.9 305.1c.8 2.8 9.3 2.5 17.6-4a66 66 0 0 1-17.6 4z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M228.9 305.1c.8 2.8 9.3 2.5 17.6-4a66 66 0 0 1-17.6 4z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M228.8 305.1a42.6 42.6 0 0 1 17.8-4.2c-8.4 6.6-17 7-17.8 4.2z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M278 236.9 252 293c-1.3 1-2.5-.3-2.9-.2-1.5 1.9-3.8 2.3-4.2 2.7-1.9 2.6-.8 4.7-.7 4.9 1.5 1.8-1.6 3.7-1.4 4.3-.6 1.1-2.9 1-3.3 2.2-.1-.1-4.5 9-5 10-.6.5-3.7 6.5-3.7 6.5-2.3 0-11-5.4-11.2-5.3 4.7-7.9 16.1-20 15.9-20.7 3.2-5.6 8.3-11.7 10.5-11.7 3.2-1.8 4.7-6.1 4-7 2.5-.2 3.8-1.7 4-1.8l19.2-40.3c1.7-.6 1.4 0 2 1l1-1.4c.9-.5 1.8.2 1.8.6z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M278 236.9 252 293c-1.3 1-2.5-.3-2.9-.2-1.5 1.9-3.8 2.3-4.2 2.7-1.9 2.6-.8 4.7-.7 4.9 1.5 1.8-1.6 3.7-1.4 4.3-.6 1.1-2.9 1-3.3 2.2-.1-.1-4.5 9-5 10-.6.5-3.7 6.5-3.7 6.5-2.3 0-11-5.4-11.2-5.3 4.7-7.9 16.1-20 15.9-20.7 3.2-5.6 8.3-11.7 10.5-11.7 3.2-1.8 4.7-6.1 4-7 2.5-.2 3.8-1.7 4-1.8l19.2-40.3c1.7-.6 1.4 0 2 1l1-1.4c.9-.5 1.8.2 1.8.6z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M278.8 224.7c-.5 1 .3 1 .6 1.2l1.2.3c1.3 0 2 .7 2 1.1L252 293.1c-1.3 1-2.6-.3-3 0l21-45 10.2-20.2-3-1.2c-.9-.2-1.1-.8-.8-1.7l13-23.3-10.4 22.6-.2.4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M278.8 224.7c-.5 1 .3 1 .6 1.2l1.2.3c1.3 0 2 .7 2 1.1L252 293.1c-1.3 1-2.6-.3-3 0l21-45 10.2-20.2-3-1.2c-.9-.2-1.1-.8-.8-1.7l13-23.3-10.4 22.6-.2.4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M237.8 293.2c-3.1 0-4.8 2.3-2.7 5m1.4-2.5c-1.1.7-1.8-.3-1.8-.3m16-14.2c-1.6 6-4.5 10-5.1 11.3-2.3 2.3-4 7.7-3.7 8.6l-8.3 14.4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M251.9 293.3c-1.5-.5-6.2-4.7-10.8-4-3.4 4.2-5.4 8.4-6 9a55 55 0 0 0 8.2 5.6c.7-.4 1-1.6 1-1.6 1-1-.2-1.9-.2-1.9 0-2.6 2-4.5 3.9-4.6 2.4-.3 1.7-.4 2-.5 1.1-.6 1.9-2 1.9-2z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M251.9 293.3c-1.5-.5-6.2-4.7-10.8-4-3.4 4.2-5.4 8.4-6 9a55 55 0 0 0 8.2 5.6c.7-.4 1-1.6 1-1.6 1-1-.2-1.9-.2-1.9 0-2.6 2-4.5 3.9-4.6 2.4-.3 1.7-.4 2-.5 1.1-.6 1.9-2 1.9-2z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M247.2 293.5c-2.1 0-4.3 1-5 2.8l5-2.8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M247.2 293.5c-2.1 0-4.3 1-5 2.8m-3.8.8c.2.5.8.7 1.3.5.5-.2.7-.7.5-1.1-.2-.5-.8-.6-1.3-.5-.5.2-.7.7-.5 1.1zm2.6-3.7c.2.5.8.7 1.3.5.5-.2.7-.7.5-1-.2-.5-.7-.7-1.2-.6s-.8.7-.6 1.1z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M275.8 243.3c.8-.4 1.2-1.3.7-2.2l-5-1.7s-.6 0-1 .8c-.6.7.1 1.2.1 1.2l5.2 1.9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M275.8 243.3c.8-.4 1.2-1.3.7-2.2l-5-1.7s-.6 0-1 .8c-.6.7.1 1.2.1 1.2l5.2 1.9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#00e519",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M278 302.2a41 41 0 0 0-18-4c8.6 6.6 17.2 6.8 18 4z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe533",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M278 302.2c-.8 2.8-9.4 2.6-18-3.9a68 68 0 0 0 18 3.9z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M278 302.2c-.8 2.8-9.4 2.6-18-3.9a68 68 0 0 0 18 3.9z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M278 302.1c-4.5-3-17-4.2-18-3.9 8.6 6.5 17.2 6.8 18 4z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m226.9 234 27.4 56.4c1.4 1 2.5-.4 3-.2 1.6 1.8 3.8 2.2 4.3 2.6 2 2.6.9 4.7.8 4.9-1.5 2 1.6 3.8 1.5 4.4.6 1 3 .8 3.4 2.1l5.1 10c.7.5 4 6.6 4 6.6 2.3 0 11-5.7 11.2-5.6-5-7.8-16.7-19.9-16.5-20.7-3.3-5.6-8.6-11.7-10.9-11.6-3.2-1.7-4.8-6-4.1-7-2.5-.1-3.9-1.6-4-1.7l-20.3-40.5c-1.7-.6-1.4.1-2 1.1l-1-1.4c-1-.5-1.9.2-1.9.6z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M225.8 221.7c.6 1-.3 1-.5 1.2l-1.2.4c-1.3 0-2 .7-2 1l32.2 66c1.4 1.1 2.7-.2 3.1 0l-22.1-45.1-10.7-20.3 2.9-1.2c.9-.2 1.2-.8.8-1.8l-13.6-23.3 11 22.7.1.4"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M225.8 221.7c.6 1-.3 1-.5 1.2l-1.2.4c-1.3 0-2 .7-2 1l32.2 66c1.4 1.1 2.7-.2 3.1 0l-22.1-45.1-10.7-20.3 2.9-1.2c.9-.2 1.2-.8.8-1.8l-13.6-23.3 11 22.7.1.4"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M268.7 290.3c3.1-.1 4.9 2.2 2.8 5m-1.4-2.5c1 .6 1.8-.4 1.8-.4m-16.4-14c1.7 6 4.7 10 5.3 11.2 2.3 2.4 4.3 7.8 3.9 8.7l8.7 14.4"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M254.5 290.6c1.4-.5 6.1-5 10.8-4.2 3.5 4.2 5.6 8.3 6.2 9a53 53 0 0 1-8.2 5.8c-.7-.5-1-1.7-1-1.7-1-1 .2-1.9.2-1.9-.1-2.6-2-4.5-4-4.6-2.5-.2-1.8-.4-2.1-.4a6.2 6.2 0 0 1-2-2z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M254.5 290.6c1.4-.5 6.1-5 10.8-4.2 3.5 4.2 5.6 8.3 6.2 9a53 53 0 0 1-8.2 5.8c-.7-.5-1-1.7-1-1.7-1-1 .2-1.9.2-1.9-.1-2.6-2-4.5-4-4.6-2.5-.2-1.8-.4-2.1-.4a6.2 6.2 0 0 1-2-2z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M259.2 290.7c2.1 0 4.4 1 5 2.8l-5-2.8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M259.2 290.7c2.1 0 4.4 1 5 2.8m4 .7c-.2.5-.8.7-1.3.6-.5-.2-.8-.7-.6-1.2.2-.4.8-.6 1.3-.5.5.2.8.7.6 1.1zm-2.7-3.6c-.2.4-.8.6-1.3.4-.6-.1-.8-.6-.6-1 .2-.5.8-.7 1.3-.6.5.2.8.7.6 1.2z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M229.3 240.4c-.8-.3-1.2-1.3-.8-2.2l5-1.8s.7 0 1.2.8c.5.7-.2 1.2-.2 1.2l-5.2 2"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M229.3 240.4c-.8-.3-1.2-1.3-.8-2.2l5-1.8s.7 0 1.2.8c.5.7-.2 1.2-.2 1.2l-5.2 2"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#00e519",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M283.3 305.1c-4-2.9-16-4.6-17.7-4.1 8.4 6.6 17 7 17.7 4.1z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe533",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M283.3 305.1c-.8 2.8-9.3 2.5-17.6-4a66 66 0 0 0 17.6 4z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M283.3 305.1c-.8 2.8-9.3 2.5-17.6-4a66 66 0 0 0 17.6 4z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M283.3 305.1a42.6 42.6 0 0 0-17.7-4.2c8.4 6.6 17 7 17.7 4.2z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m234.1 236.9 26 56.2c1.4 1 2.5-.3 3-.2 1.5 1.9 3.7 2.3 4.2 2.7 1.8 2.6.8 4.7.6 4.9-1.4 1.8 1.6 3.7 1.5 4.3.6 1.1 2.9 1 3.3 2.2.1-.1 4.5 9 4.9 10 .7.5 3.8 6.5 3.8 6.5 2.2 0 11-5.4 11.2-5.3-4.7-7.9-16.2-20-16-20.7-3-5.6-8.2-11.7-10.5-11.7-3.1-1.8-4.6-6.1-4-7-2.4-.2-3.7-1.7-3.9-1.8L239 236.7c-1.7-.6-1.4 0-2 1l-1-1.4c-.9-.5-1.8.2-1.9.6z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m234.1 236.9 26 56.2c1.4 1 2.5-.3 3-.2 1.5 1.9 3.7 2.3 4.2 2.7 1.8 2.6.8 4.7.6 4.9-1.4 1.8 1.6 3.7 1.5 4.3.6 1.1 2.9 1 3.3 2.2.1-.1 4.5 9 4.9 10 .7.5 3.8 6.5 3.8 6.5 2.2 0 11-5.4 11.2-5.3-4.7-7.9-16.2-20-16-20.7-3-5.6-8.2-11.7-10.5-11.7-3.1-1.8-4.6-6.1-4-7-2.4-.2-3.7-1.7-3.9-1.8L239 236.7c-1.7-.6-1.4 0-2 1l-1-1.4c-.9-.5-1.8.2-1.9.6z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M233.3 224.7c.5 1-.3 1-.6 1.2l-1.1.3c-1.3 0-2 .7-2 1.1l30.6 65.8c1.3 1 2.6-.3 3 0l-21-45-10.2-20.2 3-1.2c.8-.2 1.1-.8.7-1.7l-12.9-23.3 10.3 22.5.2.5"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M233.3 224.7c.5 1-.3 1-.6 1.2l-1.1.3c-1.3 0-2 .7-2 1.1l30.6 65.8c1.3 1 2.6-.3 3 0l-21-45-10.2-20.2 3-1.2c.8-.2 1.1-.8.7-1.7l-12.9-23.3 10.3 22.5.2.5"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M274.3 293.2c3.2 0 4.9 2.3 2.8 5m-1.4-2.5c1 .7 1.8-.3 1.8-.3m-16-14.2c1.6 6 4.5 10 5 11.3 2.3 2.3 4.1 7.7 3.8 8.6l8.3 14.4"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M260.3 293.3c1.4-.5 6.2-4.7 10.8-4 3.4 4.2 5.4 8.4 6 9a53.2 53.2 0 0 1-8.3 5.6c-.6-.4-1-1.6-1-1.6-.8-1 .3-1.9.3-1.9 0-2.6-2-4.5-3.9-4.6-2.4-.3-1.7-.4-2-.5-1.1-.6-1.9-2-1.9-2z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M260.3 293.3c1.4-.5 6.2-4.7 10.8-4 3.4 4.2 5.4 8.4 6 9a53.2 53.2 0 0 1-8.3 5.6c-.6-.4-1-1.6-1-1.6-.8-1 .3-1.9.3-1.9 0-2.6-2-4.5-3.9-4.6-2.4-.3-1.7-.4-2-.5-1.1-.6-1.9-2-1.9-2z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M265 293.5c2 0 4.3 1 5 2.8l-5-2.8"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M265 293.5c2 0 4.3 1 5 2.8m3.8.8c-.2.5-.8.7-1.3.5-.5-.2-.8-.7-.6-1.1.2-.5.8-.6 1.3-.5.6.2.8.7.6 1.1zm-2.6-3.7c-.2.5-.8.7-1.3.5-.5-.2-.8-.7-.6-1 .2-.5.8-.7 1.3-.6.5.2.8.7.6 1.1z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#cce5e5",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M236.4 243.3a1.6 1.6 0 0 1-.8-2.2l5-1.7s.7 0 1.1.8c.5.7-.2 1.2-.2 1.2l-5 1.9"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M236.4 243.3a1.6 1.6 0 0 1-.8-2.2l5-1.7s.7 0 1.1.8c.5.7-.2 1.2-.2 1.2l-5 1.9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#a05a2c",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m251 267.4 37.8-40.5a94.1 94.1 0 0 1-1.4-1l-38 40.5c-.5-.2 2 1.3 1.5 1z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M287.8 226.3c-1.3-1-3.7-2.3-5.3-2-.6-2.2 2.7-4.6 4-4.2-.3 2.5 3.4 4 3.3 4l-2 2.3z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M290.3 224.4c1 .9 1.4 1 3 1.7 1.4.8 3.4-1.2 4.3-1.8 0 0 1 3.6-1.2 6s-4.9 3-7 2.2c0 0 2.8-2.7 1.7-3.9-1.1-1.1-1.5-1.2-2.6-2"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M19.4-370.2h4.4v2.4h-4.4z",
    transform: "matrix(-.67726 .73575 -.82314 -.56784 0 0)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m243.4 309.7-1 9.6 1.9-2.4c.3-.6 1.6-2.2 1.9-7.9 0 0-1-3-1.5-3-.8-.5-1.3 3.7-1.3 3.7zm2.3-21.5L243 305c0 .4 1.3 1.7 2.3-1.3l1.5-11.2-1-4.4z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M251.6 303.5c-.6-.8-1.4-1.7-1.5-2.1l-.4 3.4s2.1 1.5 1.8 4.6l.5-.6.2-1.3s.5-2 .5-3.2c0 0-.5-.2-1.1-.8z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M242.4 319.3s3.6-3 3.8-10.3l.4-2s0 1.6.8.4c.7-1.6.7-3 .7-3s1.3-1.6 1.7.4l-1.3 10.2a54.8 54.8 0 0 1-.3 2.2s-.7-1.2-1.4 0c-.8 1.3-2 2.9-4.4 2.1zm4.3-26.7-1.5 11.2s1.2.6 1.4 3.2c.1 1.2.6.6.8.4.3-.8 0-2.4 0-2.4l.8-7.8s-1.4-3.6-1.5-4.6z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m245.5 318.7-.2 2.8s1 0 1.8-1.2c.8-1.3 1-3 1-3s-.7-1.3-1.3 0a4 4 0 0 1-1.3 1.4zm2-11.3a6.3 6.3 0 0 0 .6-3l-.8.6c.3 1.2.1 2.4.1 2.4z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M251 306.3c-.6-1-1.4-1.6-1.4-1.6l-1.6 12.7s-.4 3.2-2.4 4c0 0 1.1 11 4.7 8 .5-.5 1.2-3.9 1-5.9l-1-6.4a28.5 28.5 0 0 1 1.2-7.8c.2-.2 0-1.8-.6-3z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m252.7 304.3 1.1 1c.2 0-2.5 20.7-2.5 20.7s0-2.2-.7-6.4c-.7-3.4.2-8 1-10.2 0 0 .8-.7 1-5z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e214",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m248 297.4-.6 7.6s1.8-2.6 2.3-.2l.4-3.5s-1.6-2.5-2-4z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M246.7 307s-.6-6.5-3.8-2c0 0-.3 2.7 0 3.3 0 .8.9 1.8 1.3 2.5.7 1 1.4-.3 1.4-.3s.7-1 1-3.5z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M221.7 252.7c-.2-3.7-1.3-9.8-1.4-14l-12.8-13.1s-1.6 10.5-6.2 16.6l20.3 10.5"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M222.6 253.2c.5-2.6 1.2-5.5 1.6-11l-8.2-8c0 3.4-3.8 8.6-4.1 15"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M229.7 261c1-4.5-1.4-5.1 2-11.5l-7.6-7.3c-1.4 4.3-2.3 7-2.2 10.8l6.5 4.6"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M200 288c-1.5-4.5.6-13.5.4-19.3-.2-3.7 2.5-17.6 2.5-21.9l-15-9.4s-.7 15.3-2.5 32a66.3 66.3 0 0 0-.4 22.8c1.6 9.3 3.2 13.1 7 17 6.6 7 20.9 3 20.9 3 12-2.6 19-10.2 19-10.2s-4 1-10.3 1.6c-14-1-19.4 2.5-19.8-11.8"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e214",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m240.4 297.4.2-.1c-2.6 1-6.2 2-6.2 2l-8.5.7c-18.4.4-16.1-11-15.4-29.4.2-7 1.6-15.8 1.2-18.9l-12.3-7c-4 11.3-2.8 19.3-3.6 25-.4 6.4-1.8 18.6.3 24 2.9 12.4 12.6 11.9 25.8 10.8 6.5-.6 10-2.3 10-2.3l8.5-4.9"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#007a3d",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M240.6 297.1a37.3 37.3 0 0 1-6.3 2.3l-8.6.9c-13.3 1-21.1-8.3-19.4-29.5A66 66 0 0 1 209 250l7.3 4.3v.7c-.4 2.2-1.4 7.5-1.4 9.9 0 17 10.7 30 25.4 32.3l.2-.1"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M192 246c1.2 2 8.6 13.3 12.7 15.5m-11.5-8.2c1.2 2.1 10.3 14.9 14.4 15.6m-16.5 3.9c2 2.5 4.1 7.4 10.3 10.6M194 287c4.1 4 14.4 12.4 24.3 12.8m-24.3-6.4c2 2.5 6.6 14.2 25.6 8.9m-28.5-6.7c1.2 2.8 10.8 18.4 27.7 12.3"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M211 282.5c-1.6-4.6.5-13.6.3-19.4-.2-3.7 1.5-16.5 1.5-20.8l-14.1-10.5s-.7 15.3-2.4 32c-1.6 8.5-2.7 19-1.6 25.5 2 10.6 7 13.6 8 14.5 7.2 6.4 23.4 5.7 25 5.2 11.6-4.2 16.6-11.6 16.6-11.6s-5.5 0-11.8.6c-14-1-21-.4-21.4-14.7"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m251.3 291.8.2-.2c-2.6 1-6.2 2.1-6.2 2.1l-8.5.7c-18.4.4-16.1-11-15.4-29.4.2-7 .4-13.3 0-16.4l-11-8c-4 11.3-3 17.8-3.7 23.6-.4 6.3-1.8 18.5.3 23.8 2.8 12.5 12.6 12 25.7 10.9 6.6-.6 10-2.3 10-2.3l8.6-4.9"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M251.6 291.6a37 37 0 0 1-6.3 2.3l-8.6.8c-13.3 1.2-21.2-8.2-19.5-29.4 0-7.5-.2-8 2.4-18 4 2.6 11.9 9.3 11.9 9.3s-2.1 3-1.6 7.2c0 17 6.8 25.7 21.5 27.9l1.6-14"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M202.8 240.3a60.7 60.7 0 0 0 12.8 15.6m-11.5-8.2c1.2 2.2 10.3 14.9 14.4 15.6m-16.5 3.9c2 2.5 4.1 7.4 10.3 10.6m-7.4 3.5c4.1 4 14.4 12.4 24.3 12.8m-24.3-6.4c2 2.5 6.6 14.2 25.6 8.9m-28.5-6.7c1.2 2.8 10.7 18.4 27.7 12.3"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m188 238.9-.8 6.4c-.3 4.7-.1 8.2.1 10.5 0 .2.9 5.8.6 6.1-1 1.3-1.1 1.4-2.3.5-.1-.2.5-6 .6-6.8l.4-10.5c0-1.1 1-6.8 1-6.8s.1-1.3.3.6"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m188 238.9-.8 6.4c-.3 4.7-.1 8.2.1 10.5 0 .2 1.1 8 .7 6.1-1 1.3-1.3 1.7-2.4.8-.2-.2.5-6.3.6-7l.4-10.6c0-1.1 1-6.8 1-6.8s.1-1.3.3.6z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e214",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M187.8 237s-1.2 6.5-1.3 10.2c-.2 4.5-.4 5.8-.3 8.5l-.6 4.8c-.1.7.1.1 0 .2-1 .6-1.6.1-2.1-.3-.2-.2 1.5-4 1.5-4.9.9-11.4 2.5-18.2 2.5-18.2s-.6 4.1.3-.3"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M187.8 237s-1.2 6.5-1.3 10.2c-.2 4.5-.4 5.8-.3 8.5l-.6 4.8c-.1.7.1.1 0 .2-1 .6-1.6.1-2.1-.3-.2-.2 1.5-4 1.5-4.9.9-11.4 2.5-18.2 2.5-18.2s-.6 4.1.3-.3zm-.5 18.5s-1 .4-1.1.2m0-1.4s.8 0 1-.2m-.1-1.2s-.7.4-.8.2m.7-1.8h-.6m.7-1.6h-.7m.6-2.3s-.4.2-.4 0m.5-1.9h-.5m-.5 10.2s-1 .1-1.1-.2m1.1-2s-1 0-1-.2m1-1.4h-.8m1-1.5h-.7m.7-1.8-.5-.1m.7-1.5s-.5 0-.6-.2m.7-1.7s-.4.3-.4 0m0 9.6s-1 0-1-.3m13.6-21.1-.7 6.4c-.3 4.7-.1 8.3 0 10.5 0 .2 1 5.8.7 6.1-1.1 1.3-1.2 1.4-2.3.5-.2-.2.5-6 .5-6.8.2-.8.3-7.5.5-10.5 0-1.1 1-6.8 1-6.8s.1-1.3.3.6"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m198.8 233.3-.7 6.4a70 70 0 0 0 0 10.5c0 .2 1.2 8 .8 6.1-1 1.3-1.3 1.7-2.4.8-.2-.2.5-6.3.6-7l.4-10.6c0-1.1 1-6.8 1-6.8s.1-1.3.3.6z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M198.7 231.4s-1.2 6.5-1.4 10.2c-.1 4.5-.3 5.8-.2 8.5l-.6 4.8c-.1.7 0 .2 0 .2-1 .6-1.6.1-2.2-.3-.1-.2 1.5-4 1.6-4.9.9-11.4 2.5-18.2 2.5-18.2l.3-.3"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M198.7 231.4s-1.2 6.5-1.3 10.2c-.2 4.5-.4 5.8-.3 8.5l-.6 4.8c-.1.7 0 .2 0 .2-1 .6-1.6.1-2.2-.3-.1-.2 1.5-4 1.6-4.9.9-11.4 2.5-18.2 2.5-18.2l.3-.3zm-.5 18.5s-1 .4-1.1.2m0-1.4s.7 0 .9-.2m0-1.2s-.7.4-.8.2m.7-1.8h-.6m.7-1.6h-.7m.6-2.3s-.4.2-.5 0m.6-1.9h-.6m-.5 10.2s-1 .1-1-.2m1.1-2s-1 0-1-.2m1-1.4h-.8m1-1.5h-.8m.8-1.8-.5-.1m.7-1.5s-.5 0-.6-.2m.7-1.7s-.5.3-.5 0m0 9.6s-1 0-1-.3"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M207.3 225.3s.5 5.5.2 8.6c-.4 3.8-.3 4.9-.7 7v4.3c.9.5 1.6.2 2.2-.1.2-.1-1-3.5-1-4.2.4-9.5-.5-15.3-.5-15.3l-.2-.2"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M207.3 225.3s.5 5.5.2 8.6c-.4 3.8-.3 4.9-.7 7v4.3c.9.5 1.6.2 2.2-.1.2-.1-1-3.5-1-4.2.4-9.5-.5-15.2-.5-15.2l-.2-.4zm-.4 15.7s1 .2 1.1 0m-.8-1.8s.9.1 1-.1m-1-1.3h.9m-.8-1.2h.7m-.5-1.6h.5m-.5-1.3h.5m-.4-1.5s.4.3.4 0m-1 8s1 0 1-.2"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#005000",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M241 236.4h1-1z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M252.5 273.5s-.4-.2-.5 0l.2.2.3-.2zm-1 1.2 2.2-.2"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M226.3 303.1c-.2 3.3-7.8 7-13.5.2-6-4.8-4.7-12.2 0-13.2l58.3-56.8c2.4-1.3 2.6-2.5 3.8-3.7 2.4 2.6 7.5 7.2 10.2 9.5-1.7 1.4-3 2.7-3.4 3.8l-55.4 60.2z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M275 229.4c2.8-3.8 13.6 6 10.7 9.2-2.9 3-13.3-5.4-10.7-9.2z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#cccccf",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M284.8 237.8c-2 1.6-10-5-8.6-7.6 2.1-2.4 10.8 6.1 8.6 7.6z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M281.6 243a16.8 16.8 0 0 1-10.5-9.6m-24.5 48a17.3 17.3 0 0 1-12.2-12.5m9.7 15.3a17.3 17.3 0 0 1-12.2-12.4m-2.3 27.5a19 19 0 0 1-13-13m10.5 15.8a19.2 19.2 0 0 1-13-13"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M212.6 304c-.3 1.5-1 2-2.2 1.5m14.7-2c-2.3 3.6-4.9 2.5-7 2.5"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M209.5 304.2c0 1 .8 1.8 1.8 1.8a1.8 1.8 0 0 0 1.9-1.8c0-1-.8-1.8-1.9-1.8-1 0-1.8 1.1-1.8 2"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M212.8 303.9c-.3 1.4-1 1.9-2.2 1.4m14.5-1.9c-2.3 3.7-4.9 2.6-7 2.6"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m268.6 309.7 1 9.6-1.9-2.4c-.3-.6-1.6-2.2-1.9-7.9 0 0 1-3 1.5-3 .8-.5 1.3 3.7 1.3 3.7zm-2.4-21.5 2.9 16.9c0 .4-1.3 1.7-2.3-1.3l-1.5-11.2 1-4.4z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M260.4 303.5c.6-.8 1.4-1.7 1.5-2.1l.4 3.4s-2.2 1.5-1.8 4.6l-.5-.6-.2-1.3-.5-3.2s.5-.2 1.1-.8z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M269.6 319.3s-3.6-3-3.8-10.3l-.4-2s0 1.6-.8.4c-.7-1.6-.7-3-.7-3s-1.3-1.6-1.7.4a1925.6 1925.6 0 0 0 1.6 12.4s.7-1.2 1.4 0c.8 1.3 2 2.9 4.4 2.1zm-4.3-26.7 1.5 11.2s-1.2.6-1.4 3.2c-.1 1.2-.6.6-.8.4-.3-.8 0-2.4 0-2.4l-.8-7.8s1.4-3.6 1.5-4.6z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m266.5 318.7.2 2.8s-1 0-1.7-1.2c-.9-1.3-1.2-3-1.2-3s.8-1.3 1.4 0a4 4 0 0 0 1.3 1.4zm-2-11.3a6.3 6.3 0 0 1-.6-3l.7.6c-.2 1.2 0 2.4 0 2.4z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M261 306.3c.6-1 1.4-1.6 1.4-1.6l1.6 12.7s.4 3.2 2.4 4c0 0-1.1 11-4.7 8-.5-.5-1.2-3.9-1-5.9l1-6.4a28.5 28.5 0 0 0-1.2-7.8c-.2-.2 0-1.8.6-3z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M259.4 304.3s-1 1-1.2 1c-.2 0 2.5 20.7 2.5 20.7s0-2.2.7-6.4c.7-3.4-.2-8-1-10.2 0 0-.8-.7-1-5z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e214",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m264 297.4.6 7.6s-1.8-2.6-2.3-.2l-.4-3.5s1.6-2.5 2-4z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M265.3 307s.6-6.5 3.8-2c0 0 .3 2.7 0 3.3 0 .8-.9 1.8-1.3 2.5-.7 1-1.4-.3-1.4-.3s-.7-1-1-3.5z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M290.4 252.7c0-3.7 1.2-9.8 1.3-14l12.8-13.1s1.6 10.5 6.2 16.6l-20.3 10.5"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M289.4 253.2c-.5-2.6-1.2-5.5-1.6-11l8.2-8c0 3.4 3.9 8.6 4.1 15"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M282.3 261c-1-4.5 1.4-5.1-2-11.5l7.6-7.3c1.4 4.3 2.3 7 2.2 10.8l-6.5 4.6"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M312 288c1.5-4.5-.6-13.5-.4-19.3.2-3.7-2.5-17.6-2.5-21.9l15-9.4s.7 15.3 2.5 32c1.5 8.5 1.5 16.3.4 22.8-1.6 9.3-3.2 13.1-7 17-6.6 7-20.9 3-20.9 3-12-2.6-19-10.2-19-10.2s4 1 10.3 1.6c14-1 19.4 2.5 19.8-11.8"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e214",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m271.6 297.4-.2-.1c2.6 1 6.2 2 6.2 2l8.5.7c18.4.4 16.1-11 15.4-29.4-.2-7-1.6-15.8-1.2-18.9l12.3-7c4 11.3 2.8 19.3 3.6 25 .4 6.4 1.8 18.6-.3 24-2.8 12.4-12.6 11.9-25.7 10.8a31.7 31.7 0 0 1-10.1-2.3l-8.5-4.9"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#007a3d",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M271.4 297.1a37 37 0 0 0 6.3 2.3l8.6.9c13.3 1 21.1-8.3 19.4-29.5A66 66 0 0 0 303 250l-7.3 4.3v.7c.4 2.2 1.4 7.5 1.4 9.9 0 17-10.7 30-25.4 32.3l-.2-.1"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M320 246c-1.2 2-8.6 13.3-12.8 15.5m11.6-8.2c-1.2 2.1-10.3 14.9-14.4 15.6m16.5 3.9c-2 2.5-4.1 7.4-10.3 10.6m7.4 3.5c-4.2 4-14.4 12.4-24.4 12.8m24.4-6.4c-2 2.5-6.6 14.2-25.6 8.9m28.5-6.7c-1.2 2.8-10.7 18.4-27.7 12.3"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M301 282.5c1.6-4.6-.5-13.6-.3-19.4.2-3.7-1.5-16.5-1.5-20.8l14.1-10.5s.7 15.3 2.4 32c1.6 8.5 2.7 19 1.6 25.5-2 10.6-7 13.6-8 14.5-7.2 6.4-23.4 5.7-25 5.2-11.6-4.2-16.7-11.6-16.7-11.6s5.5 0 11.9.6c14-1 21-.4 21.4-14.7"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m260.7 291.8-.2-.2c2.6 1 6.2 2.1 6.2 2.1l8.5.7c18.4.4 16.1-11 15.4-29.4-.2-7-.4-13.3 0-16.4l11-8c4 11.3 3 17.8 3.7 23.6.4 6.3 1.8 18.5-.3 23.8-2.8 12.5-12.5 12-25.7 10.9-6.6-.6-10-2.3-10-2.3l-8.6-4.9"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M260.4 291.6a36.8 36.8 0 0 0 6.3 2.3l8.6.8c13.3 1.2 21.2-8.2 19.5-29.4 0-7.5.2-8-2.4-18-4 2.6-11.9 9.3-11.9 9.3s2.1 3 1.6 7.2c0 17-6.8 25.7-21.5 27.9l-1.6-14"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M309.2 240.3a60.7 60.7 0 0 1-12.8 15.6m11.6-8.2c-1.3 2.2-10.4 14.9-14.5 15.6m16.5 3.9c-2 2.5-4.1 7.4-10.3 10.6m7.4 3.5c-4.1 4-14.4 12.4-24.3 12.8m24.3-6.4c-2 2.5-6.6 14.2-25.6 8.9m28.5-6.7c-1.2 2.8-10.7 18.4-27.7 12.3"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e214",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m324 238.9.8 6.4c.3 4.7.1 8.2-.1 10.5 0 .2-.9 5.8-.6 6.1 1 1.3 1.1 1.4 2.3.5.1-.2-.5-6-.6-6.8l-.4-10.5c0-1.1-1-6.8-1-6.8s-.1-1.3-.3.6"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m324 238.9.8 6.4c.3 4.7.1 8.2-.1 10.5l-.8 6.1c1.1 1.3 1.4 1.7 2.5.8a64 64 0 0 0-.6-7l-.4-10.6c0-1.1-1-6.8-1-6.8s-.1-1.3-.3.6z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e214",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M324.2 237s1.2 6.5 1.3 10.2c.2 4.5.4 5.8.3 8.5l.6 4.8c.1.7-.1.1 0 .2 1 .6 1.6.1 2.1-.3.2-.2-1.5-4-1.5-4.9-.9-11.4-2.6-18.2-2.6-18.2s.7 4.1-.2-.3"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M324.2 237s1.2 6.5 1.3 10.2c.2 4.5.4 5.8.3 8.5l.6 4.8c.1.7-.1.1 0 .2 1 .6 1.6.1 2.1-.3.2-.2-1.5-4-1.5-4.9-.9-11.4-2.6-18.2-2.6-18.2s.7 4.1-.2-.3zm.5 18.5s1 .4 1.1.2m0-1.4s-.8 0-1-.2m.1-1.2s.6.4.8.2m-.7-1.8h.5m-.6-1.6h.7m-.6-2.3s.4.2.4 0m-.5-1.9h.5m.5 10.2s1 .1 1.1-.2m-1.1-2s1 0 1-.2m-1-1.4h.7m-1-1.5h.8m-.7-1.8.5-.1m-.7-1.5s.4 0 .5-.2m-.6-1.7s.4.3.4 0m0 9.6s1 0 1-.3"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e214",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m313.2 233.3.7 6.4c.3 4.7.1 8.3 0 10.5 0 .2-1 5.8-.7 6.1 1.1 1.3 1.2 1.4 2.3.5.2-.2-.5-6-.5-6.8-.2-.8-.3-7.5-.5-10.5 0-1.1-1-6.8-1-6.8s-.1-1.3-.3.6"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m313.2 233.3.7 6.4a70 70 0 0 1 0 10.5c0 .2-1.2 8-.8 6.1 1 1.3 1.3 1.7 2.4.8a64 64 0 0 0-.6-7l-.4-10.6c0-1.1-1-6.8-1-6.8s-.1-1.3-.3.6z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e214",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M313.3 231.4s1.2 6.5 1.4 10.2c.1 4.5.3 5.8.2 8.5l.6 4.8c.1.7 0 .2 0 .2 1 .6 1.6.1 2.2-.3.1-.2-1.5-4-1.6-4.9-.9-11.4-2.5-18.2-2.5-18.2l-.3-.3"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M313.3 231.4s1.2 6.5 1.3 10.2c.2 4.5.4 5.8.3 8.5l.6 4.8c.1.7 0 .2 0 .2 1 .6 1.6.1 2.1-.3.2-.2-1.5-4-1.5-4.9-.9-11.4-2.5-18.2-2.5-18.2l-.3-.3zm.5 18.5s1 .4 1.1.2m0-1.4s-.8 0-.9-.2m0-1.2s.7.4.8.2m-.7-1.8h.6m-.7-1.6h.7m-.6-2.3s.4.2.4 0m-.5-1.9h.5m.6 10.2s1 .1 1-.2m-1.1-2s1 0 1-.2m-1-1.4h.8m-1-1.5h.8m-.8-1.8.5-.1m-.7-1.5s.5 0 .6-.2m-.7-1.7s.5.3.4 0m.1 9.6s1 0 1-.3m-11.3-23.4s-.5 5.4-.2 8.5c.4 3.8.3 4.9.7 7v4.3c-.9.5-1.6.2-2.2-.1-.2-.1 1-3.5 1-4.2-.4-9.5.5-15.3.5-15.3l.2-.2"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M304.7 225.3s-.5 5.5-.2 8.6c.4 3.8.3 4.9.7 7v4.3c-.9.5-1.6.2-2.2-.1-.2-.1 1-3.5 1-4.2-.4-9.5.5-15.2.5-15.2l.2-.4zm.4 15.7s-1 .2-1.1 0m.8-1.8s-.9.1-1-.1m1-1.3h-.9m.8-1.2h-.7m.5-1.6h-.5m.5-1.3h-.5m.4-1.5s-.4.3-.4 0m1 8s-1 0-1-.2"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#005000",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M271 236.4h-1 1z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M259.5 273.5s.4-.2.5 0l-.2.2-.3-.2zm1 1.2-2.2-.2"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M225.8 229.8c0-2.2 2-3.5 2.4-3.7 1-.7 1.7-1.3 4-1.6l.1.9c0 .4-.5 1.7-2.2 2.9a12.3 12.3 0 0 1-4.3 1.5z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#a05a2c",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m225.8 229 31.6 41 1.5-1.4-32.3-41.8-.8 2.2z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M225.3 221s3.4-.4 3-2.3c-.6-2-2.9-2-3.8-2-1 0-4.2.6-5 1.6-1 1-3 2.6-2.4 5.3a21.3 21.3 0 0 0 2.5 6.3c1 1.8.7 3.5.5 4.2-.1.3-.4 1.4.4 1.8 1.3.5 1.6.5 2.7-.7s2.6-3.1 2.6-5.4c0-2.2 2-3.5 2.4-3.7 1-.7 1.7-1.3 4-1.6 0 0-.9-1.3-2-1.2a9 9 0 0 1-5-2.3z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M225.3 221s3.4-.4 3-2.3c-.6-2-2.9-2-3.8-2-1 0-4.2.6-5 1.6-1 1-3 2.6-2.4 5.3a21.3 21.3 0 0 0 2.5 6.3c1 1.8.7 3.5.5 4.2-.1.3-.4 1.4.4 1.8 1.3.5 1.6.5 2.7-.7s2.6-3.1 2.6-5.4c0-2.2 2-3.5 2.4-3.7 1-.7 1.7-1.3 4-1.6 0 0-.9-1.3-2-1.2a9 9 0 0 1-5-2.3z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M225.3 221c-.5 0-1.9-.6-2.8-.3-1 .4-2.8 1.5-2.5 3.1m11-.2s-1.9.8-3.3 1.8a42 42 0 0 0-3.7 3.4c-1.1 1.1-1.4 2.6-3.7 4.2m9.5-9.7-1.5 1.1c-.6.4-.8 1-1.3 1.4"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M285.7 303.1c.2 3.3 7.8 7 13.5.2 6-4.8 4.7-12.2 0-13.2l-58.3-56.8c-2.4-1.3-2.6-2.5-3.8-3.7-2.4 2.6-7.5 7.2-10.2 9.5 1.6 1.4 3 2.7 3.4 3.8l55.4 60.2z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M237 229.4c-2.8-3.8-13.6 6-10.7 9.2 2.9 3 13.3-5.4 10.7-9.2z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "#cccccf",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M227.2 237.8c2 1.6 10-5 8.6-7.6-2.1-2.4-10.8 6.1-8.6 7.6z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M230.4 243c4.8-1.5 8.3-4.7 10.5-9.6m24.5 48a17.3 17.3 0 0 0 12.2-12.5m-9.7 15.3a17.3 17.3 0 0 0 12.2-12.4m2.3 27.5a19 19 0 0 0 13-13M285 302.2a19.2 19.2 0 0 0 13-13"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M299.4 304c.3 1.5 1 2 2.2 1.5m-14.7-2c2.3 3.6 4.9 2.5 7 2.5"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M302.5 304.2c0 1-.8 1.8-1.8 1.8a1.8 1.8 0 0 1-1.9-1.8c0-1 .9-1.8 1.9-1.8 1 0 1.8 1.1 1.8 2"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M299.2 303.9c.3 1.4 1 1.9 2.2 1.4m-14.5-1.9c2.3 3.7 4.9 2.6 7 2.6"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M277 187.2c1.9 3 4.7 8.5 5.4 12.7a24 24 0 0 1-7.5 22.3c-5.5 5-14 6.5-17.7 7.2-3.5.8-6.1 2-6.7 2.7 0-.6-.1-1.1.5-1.7 1.7-.7 4.4-1.2 8.3-2 7.7-1.6 15.8-4.5 20.2-12.9 5.8-11 2.4-19.7-2.6-28.2z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M279 220a.5.6 49.9 0 1-.6-.7.5.6 49.9 0 1 .7.7z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M284.4 218.6c-1.2.7-2.3.9-3.2 1.2l-2.4.7-1.6.7c-.8.4-1.7 1.5-1.7 1.5s1.3 1.3 2.8 1.1c1.2-.1 1.8-.5 2.4-.8.7-.3.6-.6 1.6-1.3 1-.7 1.6-2.1 2-3.1zm-6 1.3c-.4.6-1.3.5-1.8.4l-.3.3c.7 0 1.7 0 2.1-.6v-.1z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M284.3 218.7a17.7 17.7 0 0 1-4.9 3c-2 .8-4.2 1-5.3 1l-.3.3a19.6 19.6 0 0 0 5.4-1.1 16 16 0 0 0 5.1-3.2zm-2.5 4.8c-2 0-3.2.6-5.2 1-1.7.4-3.9-.5-5 1.2 4.7 3 8 1 10.2-2.2z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M277.6 227.8c-1-.8-8.6-3.4-9.9-.5 1.9 2 7.2 2.5 9.9.5z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M275.7 229.8c-.8 0-1.7-.3-2.7-.4-.9 0-1.3-.2-2-.3-1.1-.2-2.4-1.8-6.4-.6 1.5 3.6 6.8 4.4 11.1 1.4zm1.8-2c-4.1.9-9 0-10.8-1l-.3.1a17.4 17.4 0 0 0 11 1zm4.2-4.3c-2.4 1.6-5.5 2.9-12.1 2l-.2.2c9.2.8 10-.9 12.3-2.2z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M275.7 229.9c-3.2 0-5 1.5-11-1.4-.4-.3-1-.4-1.4-.6l-.6.2c.4.2 1 .2 1.5.3 7.4 3.3 7.2 1.8 11.5 1.5z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M263.7 225.7a.5.6 66.2 1 0 .5.8.5.6 66.2 1 0-.5-.8z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M263.6 226.4c-.7.2-.9 1-1 1.5l-.3.1c.2-.6.5-1.5 1.2-1.8l.1.2z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M283.6 199.3a.5.6 15.8 1 1-.9-.3.5.6 15.8 0 1 1 .3z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M279 216.7c0-2.2-1.2.9-3.3-4.1-.7-1.5-.7-2.4-1.1-4.6 1.2 2 3.2 2.4 4 3.9.8 1.4.6 3.7.5 4.8z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M274.6 208.2s1.1 2.5 2.7 4.3c1.5 1.8 1.8 4 1.8 4"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M275.7 210.3c1.4 1.9 3.2 4 3.3 6.4h.2c-.3-3-2.1-4.4-3.2-5.9l-.3-.5zm11.6 2.9c-1 .8-2 1.1-3 1.5-.5.3-1 .8-1.5 1-.3.2-.9.2-1.4.6-.7.4-2.2 2.1-2.2 2.1s1.4 1.2 2.3 1c2.5-.5 3.2-1.5 4.5-2.4 1-.8 1-2.7 1.3-3.8z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m278 218.5-.2.3c1.5-.1 3.8-1.5 5.3-2.3 2-1 3.2-1.8 4-3.3a9.5 9.5 0 0 1-4.1 3.3c-1.6.8-4 2.1-5 2z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M288.1 208.3c-.8 1-1.8 1.4-2.5 2l-1.4 1.2c-.3.2-.9.4-1.3.8-.6.6-1.6 2.3-1.6 2.3s.7.7 1.5.4c2.5-.3 3.3-1.5 4.2-3.7.5-1 1-1.9 1.1-3z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M279 212.8a.6.5 62 1 0 .8-.4.6.5 62 0 0-.8.3z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m280 215-.2.4c3-1.4 7-4.2 8.4-7-1.9 3-5 5-8.2 6.6zm8.8-11.4c-.7 1-1.6 1.6-2.3 2.1l-1.2 1.3-1.1.9c-.6.6-1.4 2.4-1.4 2.4s1 .8 1.7.5c.8-.4 1.8-1.3 2.3-1.7.5-.5.6-1.6 1.2-2.4.7-1 .8-2 .8-3z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M286.6 206.8a15.4 15.4 0 0 1-5 4v.4c2.7-1.6 3.8-3 5-4.4zm1.2-6c-.5 1-1.3 1.5-1.8 2.1l-1 1.3-.9.9c-.4.6-.8 2.3-.8 2.3s.6.6 1.2.2a12.5 12.5 0 0 0 2-1.8c.4-.4.6-1.5 1-2.3a4 4 0 0 0 .3-2.8zm-4.7-1.2c-.3.5-.4 1.1-.5 1.7l-.1-.4c.1-.5.2-1 .5-1.4h.1z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M286.3 203.8a13.8 13.8 0 0 1-4 4.2l-.1.3c2.3-1.7 3.2-3.1 4.1-4.5zm-6 10.5a3.5 3.5 0 0 0-.6-1.4h-.1c.3.6.4 1 .5 1.7l.2-.3z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M279.4 193.4a.5.3 39.5 0 1-.6.5.5.3 39.5 0 1 .6-.5z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M280.7 194.7a10 10 0 0 0-1.3-1c0 .1-.1.1 0 .2l1.4 1-.1-.2zm5.9.4c-1.2 2.5-4.1 4.3-3 8 3 2.7 3.2-4.8 3-8z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M283.8 189.5c-.5 2.6-2.8 4.8-1.3 8.2 4.3 1 2.3-4.7 1.3-8.2z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M281.3 185.6c2.1 4 2.7 6.3.1 8.9 0 0-1.3-1.3-1.6-3.5-.3-2 1.3-4.3 1.5-5.4z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M277.8 183.3c.5 2.5-1.6 3.7 1.5 7 2.2-2.7 1.1-3.4-1.5-7z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M277 187.7c-3.7.4-2.3-2.7-3.3-5.6 2.1 1.6 5 2.2 3.2 5.6zm2.3 4.8c-1-4.7-4.3-2.9-6-5 .9 3 2.2 5.1 6 5zm1.4 4.3c-2.8-.2-5-1.5-6.6-4.6 3 1.2 6.1 1.4 6.6 4.6z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M281.1 200.9c-1-1.3-1-2.1-1.5-3a9.6 9.6 0 0 0-3.3-3.9c0 3.3.5 7 4.8 6.9z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M281.8 204.3a21.5 21.5 0 0 0-6-6c1.1 2.3.6 6.6 6 6z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M281.3 209.1c-5.3-.1-4.8-5.1-4.8-7.5 1 1.5 2.1 2.7 3 3.7 1 1.2 1.8 2.4 1.8 3.8z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M280.7 212c-.5-1-.1-1.4-1-2.4-1.1-1-3-2.8-4-5-.2 2-.2 4.8 1.2 5.7 1 .8 2 1 3.8 1.8zm-4.6 7.8c-4.2-3.2-1.7-6-1.4-8.4 1.1 2.8 4 5.1 1.4 8.4zm1.6-31.1a59 59 0 0 0-3.9-6.5c2 3 3 4.9 4.1 6.9"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M276.1 220.6c.2-3.3-.7-6.1-1.3-9 .6 3 1.3 6.2 1 9.3l.3-.3zm5-7.9c-.5-2-4.5-3.3-5.4-8 .8 4.7 4.8 5.8 5.2 8.5l.1-.4zm.8-2.7v.5c-.7-3.1-4.4-4.7-5.4-8.9 1.5 4.6 4.5 5.2 5.4 8.4zm.8-4.7c-1.9-2.8-4.4-3.8-6.8-7 2.2 3.1 5 4.6 6.8 7.4v-.4zm-.1-3.6c-2-1-4-3.3-6.3-7.7 1.5 3.3 3.3 6.2 6.3 8.1v-.5zm-.9-4.3c-2.4-1.9-5.4-3.1-7.6-5.3 1.8 2 5.3 3.5 7.6 5.6v-.3zm-1.8-4.6c-2.4-1.6-4.7-2.1-6.6-5.2 1.5 3 4 3.8 6.6 5.4v-.2zm6.7 2.3c-.9 3.3-1.6 6.8-3.8 9v-.5c1-.5 2.6-4 3.8-8.5zm-2.7-5.5c-.2 3.4-.1 7-1.9 9l-.1-.5c1.8-1.4 1.6-5.2 2-8.5zm-2.4-3.8c.6 3 .6 5.7-.2 10.2l-.2-.4c.5-2.6 1-5.3.4-9.8zm-3.7-2.4c1.2 2.5 2.2 5.1 1.4 7.8l-.2-.3c.9-2.5-.2-5-1.2-7.5zm-4.6 33.3c1.4 3.4-.4 5.9-2.7 7.3-1.7-5 1.9-4.4 2.7-7.3z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M273.3 216.7c.2 2-2 4.5-2.8 8l-.3.3c1-4.3 3.3-6 3-8.3z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M281.3 193.3a.3.5 1.9 1 1-.7-.1.3.5 1.9 0 1 .7.1z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M281.1 195.2v-1.7h-.2v1.9l.2-.2z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M280.3 193a.3.4 2 0 1-.5.2.3.4 2 0 1 .5-.3z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M280.7 194.5a8.2 8.2 0 0 1 0 .3v-.3z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M282.4 199.3a.5.3 80.5 0 1-.7 0 .5.3 80.5 1 1 .7 0z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M282.5 201.2a9.9 9.9 0 0 0-.4-1.6l.3 1.8.1-.2z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M281.2 199.7a.5.3 57 1 1-.5.5.5.3 57 0 1 .5-.5z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M282.4 201.2a8.8 8.8 0 0 1 0 .3v-.4z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M281 212.4a.3.5 12.7 1 1-.7-.3.3.5 12.7 0 1 .6.3z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m280.4 214.2.2-1.6h-.1a9.5 9.5 0 0 1-.3 1.8l.2-.2z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M281.6 213.2a.3.5 50.5 0 0 .5.5.3.5 50.5 1 0-.5-.5z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m280.2 214.5 1.4-1v.2a9.4 9.4 0 0 0-1.4 1v-.2z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M278.1 218.6a.3.5 40.4 0 1-.5-.6.3.5 40.4 0 1 .5.6z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M276.8 219.9a10 10 0 0 0 1-1.3h-.2l-1 1.4.2-.1z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M276.1 218.2a.5.6 10 0 0 1 0 .5.6 10 1 0-1 0z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M276.7 218.7c-.3.7-.1 1 0 1.2l-.1.4c-.2-.4-.3-.8-.1-1.6h.2zm-13 10c-.7.1-1-.3-1.2-.7h-.4c.4.5.8 1 1.6 1v-.2z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M263.8 229.5a.6.5 9.5 0 1 .2-.9.6.5 9.5 1 1-.2.9z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M269.5 219.8a5.9 5.9 0 0 1-4.2 6.8c-1-4.2 3-4.4 4.2-6.8z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M269.6 219.8a23 23 0 0 1-5.1 7.7h-.6a20 20 0 0 0 5.7-7.7z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M264.3 227.5a.5.4 9.8 0 1-.4-.8.5.4 9.8 1 1 .4.8z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M262.3 228a8.6 8.6 0 0 0 1.6-.7h-.2l-1.7.7h.3zm2.8-5.3c-.1 1.3-1.2 2.5-2.1 3.5-1 .9-1.1 1.2-2.4 1.6-1.4-3 3-3.5 4.5-5z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M265.1 222.7c-1.5 2.7-3.8 4-5 5.8h-.2c1.8-2.4 3.3-2.9 5.2-5.8zm-30-35.5c-1.9 3-4.7 8.5-5.4 12.7a24 24 0 0 0 7.5 22.3c5.5 5 14 6.5 17.7 7.2 3.5.8 6.1 2 6.7 2.7 0-.6.1-1.1-.5-1.7-1.7-.7-4.4-1.2-8.3-2-7.7-1.6-15.8-4.5-20.3-12.9-5.7-11-2.3-19.7 2.7-28.2z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M249.7 227.8c-.2.5-4.3 4-8 3.7-2.6-.2-3-.8-3-.8s-.3-.7 2-1.2c2.5-.5 6.7-2.1 9-1.7z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M238.8 230.7c2.8.3 5.8-.8 8-1.7"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M246.6 222.6a11 11 0 0 1 4.9 4c1 1.6.8 2 .8 2s-.3.3-1.4-1c-1.2-1.4-3.6-3.6-4.3-5z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M252.3 228.5c-1-1.8-2.7-3.3-4-4.5"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M235 187.6c-.1-.4.3-3.7 2.1-4.7 1.4-.8 1.9-.6 1.9-.6s.4.3-.5 1.4c-1 1-2.3 3.3-3.6 3.9z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M239 182.3c-1.6.8-2.5 2.4-3.2 3.7"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M234 189.3c-.2-.3-1-3.2-.2-5 .6-1.5 1-1.6 1-1.6s.3 0 .1 1.4c-.2 1.4-.2 4-.9 5.2z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M234.7 182.8c-.7 1.5-.7 3.3-.7 4.7"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M234 189.3a9 9 0 0 0 4.1-2.2c1-1.1.9-1.4.9-1.4s-.1-.2-1.2.6c-1 .8-3 2-3.8 3z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M239 185.7c-1 1.2-2.5 2-3.6 2.8"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M232.7 191.6c-.1-.3-1.4-3.4-.9-5.6.3-1.6.7-1.8.7-1.8s.3 0 .3 1.5c0 1.6.3 4.5 0 5.9z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M232.5 184.3c-.5 1.7-.2 3.7 0 5.3"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M231.8 193.7c-.3-.2-2.4-3.1-2.2-5.6.1-1.8.5-2 .5-2s.5-.2.7 1.5c.3 1.6 1.3 4.5 1 6z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M230.1 186.1c-.2 2 .5 4 1 5.6"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M230.6 196.4a10 10 0 0 1-2.5-5c-.2-1.7 0-2 0-2s.3 0 .8 1.4c.5 1.5 1.7 4.2 1.7 5.6z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M228.2 189.5c0 1.8 1 3.7 1.6 5.1"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M232.8 191.6c.3 0 3.4-.3 4.8-1.8 1-1.2 1-1.6 1-1.6s-.1-.3-1.3.4c-1.3.8-3.7 1.9-4.5 3z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M238.6 188.3c-1.1 1.2-2.8 2-4.2 2.6"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M231.8 193.7c.2 0 3.4 0 5-1.5 1-1 1-1.5 1-1.5s-.1-.3-1.4.4c-1.2.7-3.7 1.6-4.6 2.6z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M237.8 190.8c-1.2 1.2-3 1.8-4.3 2.3"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M230.8 196.4c.3.1 3.6-.1 5.2-1.8 1.2-1.1 1.1-1.6 1.1-1.6s-.1-.4-1.4.4c-1.4.8-4 2-5 3z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M237 193c-1.1 1.4-3 2.2-4.4 2.8"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M231.3 195.2s-.3-.6-.3-1.1l.1-.9h-.2l-.1.8v.3l-.5-.5-.2-.4h-.1l.3.7c.5.4.8 1.2.8 1.2"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M230 192.3a.6.4 83.5 1 1 .1 1.2.6.4 83.5 1 1-.1-1.2z",
    overflow: "visible",
    style: {
      marker: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M231.3 192.3a.4.6 19.3 1 1-.4 1.1.4.6 19.3 1 1 .4-1z",
    overflow: "visible",
    style: {
      marker: "none"
    }
  }), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m231.2 195.2 1-.7.4-.8h.2l-.5.8-.2.3.7-.1.4-.3.1.2-.7.3c-.6 0-1.4.4-1.4.4"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M234 193.7a.4.6 45.6 1 0-.8.9.4.6 45.6 1 0 .8-.8z",
    overflow: "visible",
    style: {
      marker: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M233 192.9a.4.6 19.8 1 0-.4 1.1.4.6 19.8 1 0 .4-1.1z",
    overflow: "visible",
    style: {
      marker: "none"
    }
  }), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M229.8 199.3a11 11 0 0 1-3-5c-.3-1.8 0-2 0-2s.3-.2.8 1.3c.7 1.5 2 4.2 2.2 5.7z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M226.8 192.3c.2 1.9 1.2 3.8 2 5.2"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M230 199.3c.3.1 3.8-.4 5.3-2.2 1.1-1.3 1-1.7 1-1.7s-.1-.4-1.4.5c-1.4 1-4 2.2-5 3.5z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M236.3 195.4c-1.2 1.5-3 2.4-4.5 3.1"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M229.5 202.3c.3 0 3.8-1 5.4-2.9 1.2-1.3 1-1.7 1-1.7s0-.3-1.4.7-4 2.6-5 3.9z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M236 197.8c-1.3 1.4-3.2 2.5-4.6 3.4"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M229.4 202.3c-.3-.1-3.6-2.4-4-4.9-.4-1.8 0-2.1 0-2.1s.4-.3 1.1 1.3c.8 1.5 2.8 4 3 5.7z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M225.4 195.4a12 12 0 0 0 2.7 5.1"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M229.5 206c.3-.1 3.6-1.8 5-4 .9-1.5.7-2 .7-2s-.2-.2-1.4 1.1c-1.1 1.3-3.6 3.4-4.3 4.8z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M235.2 200.2c-1 1.7-2.7 3.2-4 4.3"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M229.4 206c-.4 0-3.9-1.7-4.8-4.2-.6-1.8-.4-2.2-.4-2.2s.4-.3 1.4 1.1c1 1.5 3.4 3.8 3.8 5.4z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M224.3 199.7c.6 2 2.2 3.6 3.5 4.8"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M229.4 204.4s-.5-.6-.6-1.1c-.2-.6 0-1 0-1h-.4l.2 1v.3c.3.4-.4-.3-.6-.4l-.3-.5-.2.2.6.6c.6.3 1.2 1 1.2 1"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M227.2 201.7a.6.4 69.4 1 1 .5 1.2.6.4 69.4 1 1-.5-1.2z",
    overflow: "visible",
    style: {
      marker: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M228.6 201.3a.4.6 5.2 1 1-.1 1.3.4.6 5.2 1 1 .1-1.3z",
    overflow: "visible",
    style: {
      marker: "none"
    }
  }), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M229.4 204.3s.5-.4.8-1c.3-.5.3-.8.3-.8h.2l-.3.8a4.2 4.2 0 0 1-.1.4l.7-.3.4-.4.1.2-.6.5c-.7.2-1.4.8-1.4.8"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M232 202a.4.6 31.5 1 0-.6 1.2.4.6 31.5 1 0 .6-1.1zm-1.3-.5a.4.6 5.7 1 0-.1 1.2.4.6 5.7 1 0 .1-1.2z",
    overflow: "visible",
    style: {
      marker: "none"
    }
  }), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M229.8 209.3c-.4 0-4-1.9-5.5-4.3-1-1.8-.9-2.2-.9-2.2s.3-.4 1.6 1c1.3 1.5 4 3.9 4.8 5.5z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M223.5 202.8c1 2 3 3.6 4.4 5"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M230 209.2c.4 0 4.3-2 5.2-4.6.8-2 .4-2.4.4-2.4s-.4-.4-1.5 1.2c-1.1 1.5-3.6 4-4 5.8z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M235.6 202.3c-.7 2.1-2.5 3.9-3.8 5.3"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M231 212.5c.4 0 4-2.3 4.9-5 .6-2 .3-2.5.3-2.5s-.3-.3-1.3 1.4c-1.1 1.6-3.5 4.4-3.9 6.1z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M236.2 205.1c-.6 2.2-2.3 4-3.5 5.6"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M230.8 212.5c-.5 0-5-1.3-6.7-4-1.1-2-.9-2.6-.9-2.6s.4-.5 1.9 1c1.6 1.5 4.8 3.8 5.7 5.6z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M223.3 206c1.1 2.2 3.4 3.8 5.2 5"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M234.8 219.4a12 12 0 0 0 3-6c.1-1.9-.2-2.2-.2-2.2s-.4-.1-.9 1.6c-.5 1.8-1.9 5-1.9 6.6z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M237.6 211.3c0 2.1-1 4.3-1.8 6"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M234.6 219.3c-.4.2-5.6 0-8-2.2-1.9-1.7-1.8-2.4-1.8-2.4s.3-.5 2.3.5c2 1.1 6.1 2.5 7.5 4.1z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M224.9 214.8c1.9 1.9 4.7 2.9 7 3.6"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M232.7 216.6c-.4 0-5-1-7.3-3.4-1.6-1.7-1.5-2.2-1.5-2.2s.2-.4 2 .9c1.9 1.2 5.5 3.1 6.8 4.7z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M224 211c1.6 2 4.2 3.3 6.2 4.3"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M233 216.5c.3-.2 3.8-3 4.2-6 .2-2.1-.2-2.6-.2-2.6s-.5-.2-1.2 1.6c-.8 1.9-2.8 5-2.8 7z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M237 208c-.2 2.4-1.6 4.6-2.7 6.4"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M232 214.9s-.8-.3-1.2-.9c-.4-.5-.5-.9-.5-.9h-.3l.5 1 .3.3-.8-.1-.6-.4v.3s.5.4.8.4a4 4 0 0 1 1.6.5"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M228.5 213.1a.7.5 45.9 1 1 1 1 .7.5 45.9 1 1-1-1z",
    overflow: "visible",
    style: {
      marker: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M229.8 212.1a.7.5 71.6 1 1 .4 1.4.7.5 71.6 1 1-.4-1.4z",
    overflow: "visible",
    style: {
      marker: "none"
    }
  }), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M232 214.9s.4-.8.5-1.4c0-.7-.2-1-.2-1l.3-.2v1.5l.6-.6.3-.6.2.1s-.2.7-.4.9a4 4 0 0 0-1 1.4"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M233.7 211.4a.5.7 8 1 0-.2 1.4.5.7 8 1 0 .2-1.4z",
    overflow: "visible",
    style: {
      marker: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M232.1 211.3a.7.5 72.2 1 0 .5 1.4.7.5 72.2 1 0-.5-1.4z",
    overflow: "visible",
    style: {
      marker: "none"
    }
  }), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M236.6 221.4c-.4.2-4.6 1.2-7.3-.2-2-1-2-1.6-2-1.6s0-.5 2 0c2 .4 5.6.8 7.3 1.8z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M227.3 219.7c2.1 1.1 4.7 1.4 6.7 1.6"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M236.8 221.4c.2-.2 2-2.8 2-5.2 0-1.8-.4-2.1-.4-2.1s-.3-.2-.6 1.4c-.3 1.6-1.2 4.3-1 5.9z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M238.4 214.2c.2 1.9-.5 3.8-1 5.3"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M240.6 224.4c-.4.2-5.5 1.5-8.5.2-2.3-1-2.4-1.5-2.4-1.5s0-.6 2.4-.2c2.3.4 6.6.4 8.5 1.5z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M229.8 223.1c2.4 1.1 5.4 1.2 7.8 1.3"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M240.8 224.3c.2-.3 1.3-4 0-6-1-1.4-1.5-1.4-1.5-1.4s-.5.1-.1 1.7c.4 1.6.6 4.6 1.6 5.7z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M239.3 217c1.1 1.4 1.3 3.6 1.4 5.2"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M238.2 222.6s-.6.4-1.3 0c-.6-.3-.9-.7-.9-.7l-.3.2a10 10 0 0 0 1.4 1l-1 .2-.6-.2v.3l1 .1 1.6-.5"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M234.1 222.7a.8.6 24.1 1 1 1.5.6.8.6 24.1 1 1-1.5-.7z",
    overflow: "visible",
    style: {
      marker: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M235 221a.8.6 49.9 1 1 1 1.3.8.6 49.9 1 1-1-1.3z",
    overflow: "visible",
    style: {
      marker: "none"
    }
  }), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M238.3 223s.6-.6.2-1.3a2.8 2.8 0 0 0-.7-1l.2-.3.7 1 .2.5.3-1a17.5 17.5 0 0 0 0-.6h.2v1c0 .3-.6 1.6-.6 1.6"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M238.6 218.8a.8.6 69.5 1 0 .6 1.5.8.6 69.5 1 0-.6-1.5zm-1.6.8a.8.6 43.7 1 0 1.1 1.2.8.6 43.7 1 0-1.1-1.2z",
    overflow: "visible",
    style: {
      marker: "none"
    }
  }), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M243.5 226c-.2.3-4.5 3.1-7.8 2.4-2.5-.5-2.8-1.1-2.8-1.1s-.2-.6 2-.8c2.4-.2 6.5-1.2 8.6-.5z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M233 227.3c2.6.7 5.5 0 7.7-.6"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M246.2 226.7s-.5.8-1.4.6c-.9-.2-1.3-.5-1.3-.5l-.3.3 1.4.5h.5s-.6.6-1 .6l-.7.2v.3l1.2-.3c.3 0 1.6-1.2 1.6-1.2"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M241.7 228.3a1 .6 5.4 1 1 1.8.2 1 .6 5.4 1 1-1.8-.2zm.4-2a1 .6 31.2 1 1 1.6.9 1 .6 31.2 1 1-1.6-1z",
    overflow: "visible",
    style: {
      marker: "none"
    }
  }), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M244.8 226.4c.2-.4.8-4.2-1-6-1.3-1.3-2-1.2-2-1.2s-.5.2.2 1.7c.8 1.5 1.5 4.5 2.8 5.5z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M242 219.3c1.4 1.3 2 3.4 2.3 5"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M246.8 227.3s.2-.9-.5-1.4c-.7-.6-1.2-.7-1.2-.7v-.3l1.3.6.4.4s0-.8-.2-1.1a20 20 0 0 0-.4-.7l.3-.2.6 1.1.1 2"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M245 222.9a1 .6 42.7 1 0 1.4 1.2 1 .6 42.7 1 0-1.4-1.2zm-1.3 1.7a1 .6 17 1 0 1.8.5 1 .6 17 1 0-1.8-.5z",
    overflow: "visible",
    style: {
      marker: "none"
    }
  }), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M255 223s-2.5 5.7-1.6 6.3c0 0 2.5-4.5 4.8-6.2 1.1-1.1 1.8 0 2-1 .1-1-3-2.3-3-2.3l-2.1 2.9"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M255 223s-2.5 5.7-1.6 6.3c0 0 2.5-4.5 4.8-6.2 1.1-1.1 1.8 0 2-1 .1-1-3-2.3-3-2.3l-2.1 2.9"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M246 227.3s-3.7 6.4-2.7 6.4c1 .1 4.8-8 4.8-8l-1.3.2-.9 1.4z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M246 227.3s-3.7 6.4-2.7 6.4c1 .1 4.8-8 4.8-8l-1.3.2-.9 1.4z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M247 225.6s-3.8 6.2-2.8 6.3c1 0 5-8 5-8l-1.3.3-.9 1.4z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M247 225.6s-3.8 6.2-2.8 6.3c1 0 5-8 5-8l-1.3.3-.9 1.4z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M247.8 224.5s-4.3 5.8-3.4 6c1 .2 5.7-7.4 5.7-7.4h-1.3l-1 1.4z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M247.8 224.5s-4.3 5.8-3.4 6c1 .2 5.7-7.4 5.7-7.4h-1.3l-1 1.4z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M249 223.5s-5.1 5.2-4.2 5.5a35 35 0 0 0 6.7-6.6l-1.4-.1-1.1 1.2z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M249 223.5s-5.1 5.2-4.2 5.5a35 35 0 0 0 6.7-6.6l-1.4-.1-1.1 1.2z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M249.1 221.6s-4.4 5.8-3.4 6c.9.2 5.8-7.4 5.8-7.4h-1.3l-1 1.4z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M249.1 221.6s-4.4 5.8-3.4 6c.9.2 5.8-7.4 5.8-7.4h-1.3l-1 1.4z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M248 226.5s-4.3 5.9-3.4 6c1 .3 5.7-7.4 5.7-7.4l-1.3.1-1 1.3z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M248 226.5s-4.3 5.9-3.4 6c1 .3 5.7-7.4 5.7-7.4l-1.3.1-1 1.3z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M250.4 225.4s-2.5 4.7-2.2 5a17 17 0 0 0 4.9-5.6c1.5-2.8-2.8.5-2.8.5"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M250.4 225.4s-2.5 4.7-2.2 5a17 17 0 0 0 4.9-5.6c1.5-2.8-2.8.5-2.8.5"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M250.7 225s-2.5 5.7-1.6 6.3c0 0 3.1-3.5 4-6.3.7-2.8 0-.2 0-.2l-.3-3-2 2.9"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M250.7 225s-2.5 5.7-1.6 6.3c0 0 3.1-3.5 4-6.3.7-2.8 0-.2 0-.2l-.3-3-2 2.9"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M249.4 224.4s-5 5.2-4.1 5.5c.9.3 6.6-6.6 6.6-6.6h-1.3l-1.2 1.1z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M249.4 224.4s-5 5.2-4.1 5.5c.9.3 6.6-6.6 6.6-6.6h-1.3l-1.2 1.1z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M249.8 225.1s-5 5.2-4.1 5.5c.9.3 6.6-6.5 6.6-6.5l-1.3-.2-1.2 1.2z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M249.8 225.1s-5 5.2-4.1 5.5c.9.3 6.6-6.5 6.6-6.5l-1.3-.2-1.2 1.2z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M250.2 226s-5 5.1-4.1 5.4c.9.4 6.6-6.5 6.6-6.5l-1.3-.2-1.2 1.2z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M250.2 226s-5 5.1-4.1 5.4c.9.4 6.6-6.5 6.6-6.5l-1.3-.2-1.2 1.2z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M250.6 218.8s-3.8 4.8-3.2 5.6c.5.9 4-2.2 5-4.3 1.1-2.1-1.8-1.5-1.8-1.5"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M250.6 218.8s-3.8 4.8-3.2 5.6c.5.9 4-2.2 5-4.3 1.1-2.1-1.8-1.5-1.8-1.5"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M250.5 223.9s-3.3 6.2-2.4 5.8c.8-.3 4-5 4.4-6 .4-1 .3-2.1.3-2.1l-2.5 1.5.2 1.2"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M250.5 223.9s-3.3 6.2-2.4 5.8c.8-.3 4-5 4.4-6 .4-1 .3-2.1.3-2.1l-2.5 1.5.2 1.2"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M250.5 221.9s2.7-5 0 .9c-2.7 5.8-3.7 4.9-3.7 4.9-.2-.4 2.3-4.3 2.3-4.3s2-3 2.4-3.3"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M250.5 221.9s2.7-5 0 .9c-2.7 5.8-3.7 4.9-3.7 4.9-.2-.4 2.3-4.3 2.3-4.3s2-3 2.4-3.3"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M253.4 221.2s3-4.9 0 1c-3 5.7-4.2 4.8-4.2 4.8-.2-.4 2.6-4.3 2.6-4.3s2.1-3 2.6-3.3"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M253.4 221.2s3-4.9 0 1c-3 5.7-4.2 4.8-4.2 4.8-.2-.4 2.6-4.3 2.6-4.3s2.1-3 2.6-3.3"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M252.3 219.2s-3.8 4.8-3.2 5.6c.5.8 4-2.2 5-4.3 1.1-2.2-1.8-1.5-1.8-1.5"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M291 267.8a35 39.4 0 1 1-70 0 35 39.4 0 1 1 70 0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#390",
    strokeWidth: 0.9,
    d: "M228 267.8c0-18.3 12.8-32.3 28-32.3s28 14 28 32.3",
    color: "#000",
    fontFamily: "Sans",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textTransform: "none",
      marker: "none"
    }
  }), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#eee",
    strokeWidth: 0.1,
    d: "M221 269.9c1 20.8 16.3 37.3 35 37.3s34-16.5 35-37.3h-70z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M291 267.8a35 39.4 0 1 1-70 0 35 39.4 0 1 1 70 0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M250.1 240.4c-.3 1.5 0 2.7.8 3.9a5 5 0 0 1 1 2.9 8.4 8.4 0 0 0-.8.4l-6-3.9 4 5.9a8.6 8.6 0 0 0-.2.3 5.2 5.2 0 0 0-3.2-.4 5.3 5.3 0 0 1-3.9-.8 4.8 4.8 0 0 0 3.3 2.2c1 .2 2 .6 2.7 1.4l-.2.8-7 1.4 7 1.4a9 9 0 0 0 .1.3 5.2 5.2 0 0 0-2.5 2 5.3 5.3 0 0 1-3.4 2.2c1.5.4 2.8 0 4-.8.8-.5 1.8-1 2.8-.9l.5.7-4 6 6-4 .2.2a5.2 5.2 0 0 0-.4 3.2 5.3 5.3 0 0 1-.8 3.9 4.8 4.8 0 0 0 2.2-3.3 5.2 5.2 0 0 1 1.4-2.7l.9.2 1.4 7 1.3-7h.4a5.2 5.2 0 0 0 2 2.5 5.3 5.3 0 0 1 2.2 3.3 4.8 4.8 0 0 0-.8-4 5.2 5.2 0 0 1-1-2.8l.8-.5 6 4-4-5.9a8.6 8.6 0 0 0 .2-.3 5 5 0 0 0 3.2.4 5.3 5.3 0 0 1 3.9.8 4.8 4.8 0 0 0-3.4-2.2 5.2 5.2 0 0 1-2.7-1.4l.2-.9 7-1.4-7-1.3a8.3 8.3 0 0 0 0-.4 5.2 5.2 0 0 0 2.5-2 5.3 5.3 0 0 1 3.3-2.1 4.8 4.8 0 0 0-3.9.7 5.2 5.2 0 0 1-2.8 1 8.4 8.4 0 0 0-.5-.8l4-5.9-6 4a8.6 8.6 0 0 0-.2-.2c.5-1.2.6-2.2.4-3.2a5.3 5.3 0 0 1 .8-4 4.8 4.8 0 0 0-2.2 3.4 5.2 5.2 0 0 1-1.4 2.7 8.5 8.5 0 0 0-.9-.2l-1.4-7-1.3 7h-.4a5.2 5.2 0 0 0-2-2.5 5.3 5.3 0 0 1-2.2-3.3z",
    overflow: "visible",
    style: {
      marker: "none"
    }
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    width: 330,
    height: 330,
    fill: "#fcbf49",
    strokeWidth: 1.1,
    transform: "rotate(22.5 -488.5 805) scale(.15213)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    width: 330,
    height: 330,
    fill: "#fcbf49",
    strokeWidth: 1.1,
    transform: "matrix(-.15213 0 0 .15213 270.9 248.2)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M262.2 252.5c-1.7-1.5-4-1.8-5.1-.6-1 1.2-.8 2.5.2 4a.6.6 0 0 0-.3.2 5.2 5.2 0 0 1-.4-4.4c1.7-1.3 4-1.5 5.6.8"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M259.5 252c-1 0-1.2.3-1.7.6-.4.4-.7.3-.7.4-.1 0 0 .3.1.2.2 0 .5-.2 1-.6s.8-.3 1.3-.3c1.4 0 2.1 1.1 2.3 1 .1 0-.8-1.3-2.3-1.3"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M261.3 253.3c-1-1-2.9-1.1-3.6.1h.3c.7-1.2 2.6-.7 2.7-.2v.2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 259.4,
    cy: 253.3,
    r: 0.7
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M257.7 253.4c.7.7 2.4.8 3.6 0l-.6-.2c-.7.9-2 .8-2.7.2v-.2"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M261.3 253.7c-1.3 1-2.6 1-3.3.5-.8-.5-.8-.6-.6-.6l.9.4c.6.3 1.5.3 3-.3m-3.7 2.3a.5.5 0 1 1-.6.4c0 .2-.4.6-1 .6h-.1l.1.3c.1 0 .6 0 1-.2a.7.7 0 1 0 .6-1.1m1 3.2c-.8-.5-1-1.2-1.8-1.2a2 2 0 0 0-.8.3h-.1l.1.2c.3 0 .8-.4 1.3 0l1.2.7m-.2 0c-1.5-.5-1.8-.2-2.3-.2h-.1l.1.3c.6 0 1-.4 2.3-.1"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M258.5 259.2c-1.7-.2-1.1.8-2.5.8h-.1l.1.2c1.7 0 1-.9 2.5-1m-8.7-6.7c1.7-1.5 4-1.8 5.1-.6 1 1.2.8 2.6-.2 4 0 0 .2 0 .3.2a5.2 5.2 0 0 0 .4-4.4c-1.7-1.3-4-1.5-5.6.8"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M252.5 252c1 0 1.2.3 1.7.6.4.4.7.3.7.4.1 0 0 .3-.1.2-.2 0-.5-.2-1-.6s-.8-.3-1.3-.3c-1.4 0-2.1 1.1-2.3 1-.1 0 .8-1.3 2.3-1.3"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M250.8 253.3c1-1 2.8-1.1 3.5.1h-.3c-.7-1.2-2.6-.7-2.7-.2v.2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: -252.7,
    cy: 253.3,
    r: 0.7,
    transform: "scale(-1 1)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M254.3 253.4c-.7.7-2.4.8-3.5 0l.5-.2c.7.9 2 .8 2.7.2v-.2"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M250.7 253.7c1.3 1 2.6 1 3.3.5.8-.5.8-.6.6-.6l-.9.4c-.6.3-1.5.3-3-.3m3.7 2.3a.5.5 0 1 0 .6.4c0 .2.4.6 1 .6h.2l-.2.3c-.1 0-.6 0-1-.2a.7.7 0 1 1-.6-1.1m-1 3.2c.8-.5 1-1.2 1.8-1.2l.8.3h.2l-.2.2c-.3 0-.8-.4-1.3 0l-1.2.7m.2 0c1.5-.5 1.8-.2 2.3-.2h.1l-.1.3c-.6 0-1-.4-2.3-.1"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M253.5 259.2c1.7-.2 1.1.8 2.5.8h.1l-.1.2c-1.7 0-1-.9-2.5-1"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M259.4 275.6c1.7.3 3.5.2 5-.3a10.5 10.5 0 0 1 4.6-.6c0-.2.4-.4.2-.6-.6-.3-1.3-.3-2-.6-1.1-.5-1.8-1.4-3-2 0-.1-.5-.4-.5-.7 2.3 3.4 8 1.7 12.7 1.3.5.1 1.6-.2 2.6-.5 1.2-.4 4 0 4.7-.6l-1.5-1c-.6-.9-2.4-.8-3.2-1.7-1.4-1.5-3.5-2-5.1-3.2-.4-.2-1.2-.1-1.7-.3-.7-.5 0-.5-5.4-4.9-4.8-2-4.5-3.5-7.5-4.6-1-.6-2-1.5-3-1.2-1.5.4-5 2.2-6.6 3l-4 3.1c-.3.3-3.7 3.1-7.5 5.2a121 121 0 0 1-9.9 5c8.7-.4-7.7 2.5 31.1 5.2z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M238.2 265.7a59 59 0 0 0 13.2-9c-.4 0 .7 1 .6 1.4.8 0 .4-1 1-1s1-.2 1.4-.3c.5-.1.2.2.2.4-.7 1.3-2.2 2-3.4 3 .1.2.3.3.2.4.4.1 1 .1 1.2-.1l.1-.4c.5.2.3.5.1.8-.3.7-1.5.6-2 1.2a6.6 6.6 0 0 1-1.5 1.7c.5-.4 1.1-1 1.8-1 1-.1 1.4-.8 2.3-1 1-.2 1.6-1 2.4-1.6-.3.5-1 .9-.7 1.4a.6.6 0 0 0 .6.1c-.7.9-2.1 1.6-2.6 2.6-.4-.1-.7.2-1 .2-.5.2-.4.9-.7 1-1.2.8-1.9 2-2.4 3l-1.5.8c-.7.2-4.9 3.5-5 3-.3-2.2-4.6 1.8-14.1-1.6m32.6-.1-.2-.2c.1-.3-.5-.4-.5-.7 1 0 2 1.3 2.6.5.2-.1-.3-.4.4-.6.2 0-.1-.2 0-.3h-1l-.8-.3c-.3-.1-.5-.5 0-.6 1-.2 2 .5 2.8.2l1.8-.6c.3 0 1.3 0 1 .3-.3.2-.8.1-1 .2-.6.1-1 .4-1.6.6.4 0 .3.4.7.3.7-.2 1.4-.5 2.1-.5l.2-.5h.2c-.3-.5.7-.3 1-.7l.2.1c-.5.2-.3.6-.4.8l-.3.3c.3.2.3-.2.6 0h.6c.4 0 .8-.1.6-.4-.3-.3-.6-.5-.6-.9h-.2c.6 0 1 .1 1.2.4.3.2.4.6.8.7.9.2.8-.2.8-.7.7 0 1.7.4 1.5.7 0 .3-.6.5-1.1.5-.4 0-.2.3-.4.3-.4 0-1 0-1.1.3-.2.2 0 .7.3 1h2c.1-.4.6-.5 1-.8.4-.2-.3-.4-.6-.6-.3-.1-.1-.2 0-.4.3-.3 1 0 1-.2.2-.3-.1-.7.2-.8.2-.2.5.1.4.3l.7-.2c.4 0 .6.3.4.3-.4.3-.8.5-.7 1 0 .2-.5.2-.3.4.5.3.4.6.6 1 .1.4 1 .5 1.7.3-.3-.7 1.4-.3 2.2-.5v-.2c-.4-.2-.5-.3-.4-.6l-.2-.2c1.1.4 3 1 3.9 1.6-1 .2-3-.3-4 0-1.4.2-2.6.6-4 .6-.6 0-1.2-.3-1.8-.4m-12-.7-.3-.1"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M257.3 276.4c2 0 2.3 1.5 3.7.1 1.2.2 2.4-.2 2.4-.4 2.9.6 11.9-.2 11.3-.8-1-1-2.5-1.5-3.7-2.4l-1.2-.4c-.7-.2-1.6 0-2.1-.3-1-.5-2-1-2.8-1.6-.5-.4-.7-1-1.3-1.5-.6-.4-1.4-.5-2-.8-1-.3-1.5-1.3-2.4-2-.3-.2-.8-.1-1.2-.4-.7-.3-1.3-1.2-2-1-1.2.1-1.9 1.1-3 1.6-1 .5-1.5 1.3-2.3 1.8-.2.1-2.8 1.9-5.7 3a76.7 76.7 0 0 1-7 2.7s2.5 1.9 8.5 1.6l3.6 1.2 2-.4h5.1z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M245 271.8c1.4-.6 6.5-3 8-4.8-.2 0 .5.5.4.8.5 0 .3-.5.7-.6l.8-.1c.3-.1.1 0 .1.2-.4.7-1.3 1-2 1.6 0 0 .1.1 0 .2h.8l.1-.3c.3.1.2.3 0 .4-.1.4-.9.4-1.1.7l-1 1c.3-.3.7-.6 1.1-.6.7 0 .9-.4 1.4-.5.6-.2 1-.6 1.5-.9-.2.2-.6.4-.5.7l.4.2c-.4.4-1.2.7-1.5 1.3-.3-.1-.5 0-.7.1-.2 0-.2.5-.3.6-.8.3-1.2 1-1.5 1.5 0 0-.7.4-1 .4-.3.2-2.9 2-3 1.7-.2-1.2-2.6.5-8.5-1.3"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#00a6de",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M256 228.4c-19.3 0-35 17.7-35 39.4 0 21.8 15.7 39.4 35 39.4s35-17.6 35-39.4-15.7-39.4-35-39.4zm0 8.8c14.1 0 26.3 13.1 26.3 30.6s-12.2 30.6-26.3 30.6c-14.1 0-26.3-13.1-26.3-30.6s12.2-30.6 26.3-30.6z",
    color: "#000",
    fontFamily: "Sans",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textTransform: "none",
      marker: "none"
    }
  }), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M261 284.6c0 .2 0 .2-.4.2-.4.1-.5.1-.5-.1s0-.2.5-.3c.3 0 .4 0 .4.2z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "m261.1 284.6-.5.2h-.6c0-.2.3-.3.6-.3h.5zm-3 9.5c.9-2.2 1-4-.1-6.4 2-1.9 3.5-1.2 4.8.1-1.3 2.4-1 4.1-.2 6.4a4.3 4.3 0 0 1-4.5 0z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M260.3 286.5v8.3c0-2.8.2-5.5 0-8.3z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M260.7 286.6a47.4 47.4 0 0 0-.4 8.2h.2c0-3.1 0-5.7.4-8.2a3 3 0 0 0-.2 0zm.7-2.7c-.4.4-.5.4-.4 1 .4-.2.4-.5.4-1z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M260.6 284.2c.2.2.6.4.4 1-.5-.3-.4-.4-.4-1z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M260.5 284.9c.3.2.6.3.4.8-.3-.3-.4-.3-.4-.8z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M260.4 285.2c.3.3.6.4.4 1-.4-.3-.4-.3-.4-1z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M260.3 285.8c.3.2.7.3.4 1-.4-.4-.2-.5-.4-1z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M260.3 286.3c.2.2.6.4.4 1-.4-.4-.4-.4-.4-1zm1.3-1.8c-.2.1-.6.1-.6.8.5-.3.5-.2.6-.8z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M261.6 285c-.2.1-.7 0-.7.7.6-.3.6-.2.7-.7z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M261.5 285.4c-.2.1-.6.1-.7.8.6-.3.6-.2.7-.8z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M261.5 286c-.2 0-.7-.1-.7.7.4 0 .4-.3.7-.7z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M261.3 286.5c-.3.1-.5 0-.6.8.5-.4.5-.3.6-.8zm.3.4c-.8 2.2-1 4.2-.9 7.9a6.8 6.8 0 0 0 .2 0c0-3.7.1-5.7.8-7.8a3 3 0 0 0-.1-.1zm1.2-2.4c-.4.3-.6.2-.5.9.4-.2.4-.4.5-1z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M262 284.6c.2.2.5.4.1 1-.3-.4-.2-.4-.1-1z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M261.8 285.2c.2.3.5.4.2 1-.2-.5-.3-.5-.2-1z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M261.6 285.5c.2.3.5.5.2 1.1-.4-.4-.3-.5-.2-1z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M261.4 286c.2.3.6.5.2 1-.4-.4-.1-.5-.2-1z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M261.2 286.5c.2.3.6.5.2 1-.3-.3-.3-.4-.2-1zm1.8-1.4c-.3 0-.7 0-.8.6.5-.2.5-.1.8-.6z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M262.8 285.5c-.2.1-.7 0-.8.6.6-.2.6-.1.8-.6z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M262.7 286c-.3 0-.7 0-.9.6.6-.2.6-.2.9-.7z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M262.5 286.5c-.2 0-.7-.2-.9.6.5 0 .5-.3 1-.6z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M262.2 287c-.4 0-.5 0-.7.6.5-.2.5-.2.7-.7zm.1.4c-1 2-1.2 3.8-.7 7.2a5 5 0 0 0 .2 0c-.5-3.3-.3-5.2.6-7.1a3.5 3.5 0 0 0 0-.1zm1.7-2.4c-.5.2-.7.2-.7.8.4-.1.5-.3.7-.8z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M263.1 285c.2.3.4.5 0 1-.3-.4-.2-.4 0-1z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M262.8 285.6c.2.3.5.5.1 1-.1-.5-.3-.5 0-1z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M262.6 285.9c.2.3.4.6 0 1-.3-.4-.2-.4 0-1z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M262.3 286.4c.2.3.5.5 0 1-.2-.5 0-.5 0-1z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M262 286.8c.2.3.6.6.2 1-.3-.4-.3-.4-.1-1zm2-1.2c-.2 0-.6 0-.9.5.6 0 .6 0 .9-.5z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M263.8 286c-.2.1-.7 0-.9.5.7 0 .6 0 1-.5z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M263.6 286.4c-.2 0-.7 0-1 .5.7 0 .7 0 1-.5z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M263.4 287c-.3 0-.7-.4-1 .4.5 0 .5-.2 1-.5z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M263 287.4c-.3 0-.5-.1-.8.5.5-.1.5 0 .8-.5zm-3.2-.8h-.1a44 44 0 0 0 .1 0zm-.7-2.7c.4.4.6.4.4 1-.4-.3-.4-.5-.4-1z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M259.9 284.2c-.2.2-.6.3-.4 1 .5-.3.4-.4.4-1z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M260 284.9c-.3.2-.6.2-.4.8.3-.3.4-.3.4-.8z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M260 285.2c-.2.3-.5.4-.3 1 .4-.3.4-.3.4-1z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M260.2 285.8c-.3.2-.7.3-.4 1 .4-.4.2-.6.4-1z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M260.2 286.3c-.2.2-.6.3-.4 1 .4-.4.4-.4.4-1zm-1.3-1.9c.2.2.6.2.6.9-.5-.4-.5-.3-.6-.9z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M258.9 284.9c.2.1.7.1.7.8-.6-.3-.6-.3-.7-.8z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M259 285.3c.2.2.6.2.7.9-.6-.4-.6-.3-.7-.9z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M259 286c.2 0 .7-.1.7.7-.4-.1-.4-.4-.7-.8z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M259.2 286.4c.3.2.5.2.6.8-.5-.3-.5-.2-.6-.8zm-.2.6a4 4 0 0 0-.2 0c.7 2.2 1 4.2 1 7.7a20 20 0 0 0-.8-7.8zm-1.3-2.7c.4.4.6.3.6 1-.5-.2-.5-.4-.6-1z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M258.5 284.5c-.2.3-.5.5-.1 1 .3-.4.3-.4.1-1z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M258.7 285.1c-.2.3-.5.4-.2 1 .2-.4.3-.4.2-1z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M258.9 285.5c-.2.3-.5.4-.2 1 .4-.4.3-.4.2-1z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M259.1 286c-.2.3-.6.4-.2 1 .4-.4.1-.5.2-1z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M259.3 286.5c-.2.3-.6.5-.3 1 .3-.4.4-.4.3-1zm-1.8-1.6c.3.2.7 0 .8.7-.6-.2-.5-.1-.8-.7z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M257.7 285.4c.2.1.7 0 .8.6-.6-.2-.6-.1-.8-.6z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M257.8 285.8c.3.1.7 0 .9.7-.6-.2-.6-.2-.9-.7z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M258 286.4c.2 0 .7-.2.9.6-.5 0-.5-.3-1-.6z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M258.3 286.8c.3.1.5 0 .7.7-.5-.2-.5-.2-.7-.7zm0 .7h-.2c1 2 1 3.8.8 7h.2c.3-3.2.1-5-.8-7zm-1.8-2.7c.5.3.7.2.7.9-.4-.2-.5-.4-.7-.9z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M257.4 284.9c-.1.3-.4.5 0 1 .3-.4.2-.4 0-1z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M257.7 285.5c-.2.3-.5.4-.1.9.1-.4.3-.4 0-1z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M257.9 285.8c-.2.3-.4.5 0 1 .3-.4.2-.4 0-1z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M258.2 286.3c-.2.3-.5.5-.1 1 .3-.5 0-.5 0-1z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M258.4 286.8c-.2.2-.5.5 0 1 .2-.4.2-.5 0-1zm-1.9-1.4c.2.1.6 0 .9.6-.6-.1-.6 0-.9-.6z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M256.7 285.9c.2 0 .7-.1.9.5-.7-.1-.6 0-1-.5z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M256.9 286.3c.2 0 .7-.1 1 .5-.7 0-.7 0-1-.5z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M257.1 286.8c.2 0 .7-.3 1 .5-.5 0-.5-.2-1-.5z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M257.5 287.2c.3 0 .5 0 .8.6-.6-.1-.5-.1-.8-.6zm2.3-3.4c.4.5.6.5.3 1-.3-.2-.3-.5-.3-1z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M260.6 284.2c-.2.2-.6.3-.4 1 .4-.3.4-.4.4-1z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M260.6 284.9c-.3.2-.6.2-.4.8.3-.3.4-.3.4-.8z"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M260.7 285.2c-.3.3-.6.3-.4 1 .4-.3.4-.3.4-1z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M260.8 285.8c-.3.2-.7.3-.5 1 .5-.4.3-.6.5-1z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M260.8 286.3c-.2.2-.7.3-.5 1 .4-.4.5-.4.5-1zm-1.2-2c.1.2.6.3.5 1-.5-.4-.5-.4-.5-1z"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M259.6 284.8c.2.2.6.2.6.9-.6-.4-.5-.3-.6-.9z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M259.6 285.3c.2.1.7.2.7.8-.6-.3-.6-.3-.7-.8z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M259.6 285.9c.2 0 .7 0 .7.8-.4-.2-.4-.4-.7-.8z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M259.8 286.4c.3.1.5.1.5.8-.4-.3-.4-.3-.5-.8zm-.4.3h-.1c.6 2.6.7 5 .7 8h.1c.1-2.7 0-5.3-.7-8zm-1-2.5c.4.3.6.3.5 1-.5-.3-.5-.5-.6-1z"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M259.2 284.4c-.2.2-.5.4-.2 1 .3-.4.3-.4.2-1z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M259.3 285c-.2.3-.5.4-.2 1 .2-.4.3-.4.2-1z"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M259.5 285.4c-.2.2-.5.4-.2 1 .3-.4.3-.4.2-1z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M259.7 285.9c-.2.3-.6.4-.3 1 .4-.4.2-.5.3-1z"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M259.8 286.4c-.2.3-.6.4-.3 1 .3-.4.4-.4.3-1zm-1.6-1.6c.2 0 .6 0 .7.7-.5-.3-.5-.2-.7-.7z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M258.3 285.2c.2.1.7 0 .8.7-.6-.2-.6-.2-.8-.7z"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M258.4 285.6c.2.2.7.1.8.8-.6-.3-.6-.2-.8-.8z"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M258.5 286.2c.3 0 .7-.1.9.7-.5 0-.5-.3-.9-.7z"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M258.8 286.7c.4 0 .5 0 .7.7-.5-.2-.5-.2-.7-.7zm-.8 1a6.7 6.7 0 0 1 .8 4c0 .8-.2 1.7-.4 2.6h.2c.6-2.7.5-4.7-.6-6.6z"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M258.6 287.2c.8 2.3.9 4.4.7 7.5h.2a16 16 0 0 0-.9-7.5zm-1.5-2.6c.5.3.7.2.7.9-.5-.2-.5-.4-.7-.9z"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M258 284.6c-.2.3-.5.5 0 1.1.2-.4.1-.4 0-1z"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M258.2 285.3c-.2.3-.5.4-.1.9.2-.4.3-.4.1-1z"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M258.4 285.6c-.1.3-.4.5 0 1 .3-.4.2-.4 0-1z"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M258.7 286c-.2.4-.6.6-.1 1.1.3-.5 0-.5.1-1z"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M258.9 286.6c-.2.3-.5.5-.1 1 .2-.4.2-.5.1-1zm-1.9-1.4c.3 0 .7 0 .9.6-.6-.2-.6-.1-.9-.6z"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M257.2 285.6c.2.1.7 0 .9.6-.7-.1-.6 0-.9-.6z"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M257.4 286c.2.1.7 0 .9.6-.6-.1-.6 0-.9-.6z"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M257.6 286.6c.2 0 .7-.3 1 .5-.5 0-.6-.2-1-.5z"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M258 287c.3 0 .5 0 .7.6-.5-.2-.5-.1-.7-.6zm-2-1.7c.5.2.6 0 .8.7-.5 0-.6-.3-.9-.7zm.8-.1c-.1.3-.4.6.1 1 .3-.4.2-.5-.1-1z"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M257.2 285.8c-.2.3-.4.4 0 .9.1-.4.2-.4 0-1z"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M257.4 286c-.1.4-.3.6.1 1.1.3-.5.2-.5-.1-1z"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M257.8 286.5c-.2.3-.5.6 0 1 .3-.5 0-.5 0-1z"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M258 287c0 .2-.4.5 0 1 .3-.5.3-.5 0-1zm-2-1.1c.2 0 .6-.2 1 .4-.7 0-.7 0-1-.4z"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M256.2 286.3c.3 0 .7-.2 1 .4-.7 0-.6 0-1-.4z"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M256.5 286.6c.2 0 .7-.1 1 .5-.7 0-.7 0-1-.5z"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M256.8 287.1c.2 0 .6-.3 1 .4-.5.1-.6-.1-1-.4z"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M257.2 287.5c.4 0 .5 0 .8.5-.5-.1-.5 0-.8-.5zm4-.8a27.5 27.5 0 0 0-.7 8h.2c0-3 0-5.4.7-8h-.1zm1.1-2.4c-.4.3-.6.3-.5.9.4-.2.5-.4.5-1z"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M261.5 284.4c.2.3.5.5.2 1-.4-.3-.3-.4-.2-1z"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M261.3 285c.3.3.6.4.3 1-.3-.4-.4-.4-.3-1z"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M261.2 285.4c.2.3.5.5.2 1-.4-.3-.3-.4-.2-1z"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M261 286c.2.2.6.4.3 1-.5-.5-.2-.6-.3-1z"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M260.8 286.4c.3.3.6.5.3 1-.3-.3-.3-.4-.3-1zm1.7-1.5c-.2 0-.7 0-.8.7.6-.3.6-.2.8-.8z"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M262.4 285.3c-.2.1-.7 0-.8.6.6-.1.6 0 .8-.6z"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M262.3 285.7c-.3.2-.8 0-.9.7.7-.2.6-.1.8-.7z"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M262.1 286.3c-.2 0-.7-.2-.8.6.4 0 .5-.3.8-.6z"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M261.8 286.8c-.3 0-.5 0-.6.6.5-.2.4-.1.6-.6zm.2.3c-1 2.3-1.1 4.4-.9 7.6h.2c-.2-3.2 0-5.3.8-7.5zm1.5-2.4c-.4.3-.6.2-.6.9.5-.2.5-.4.7-.9z"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M262.7 284.8c.2.3.5.5 0 1-.2-.4-.2-.5 0-1z"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M262.4 285.4c.3.3.5.4.2.9-.2-.4-.3-.4-.2-1z"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M262.3 285.7c.1.3.4.5 0 1-.3-.4-.2-.4 0-1z"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M262 286.2c.2.3.5.5 0 1-.3-.5 0-.5 0-1z"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M261.8 286.6c.1.3.5.6 0 1.1-.2-.4-.2-.5 0-1zm1.8-1.3c-.2.1-.6 0-.8.6.6-.1.5 0 .8-.6z"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M263.4 285.8c-.2 0-.6-.1-.8.5.6-.1.6 0 .8-.5z"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M263.3 286.2c-.3 0-.7-.1-1 .5.7 0 .7 0 1-.5z"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M263 286.7c-.2 0-.6-.3-.9.5.5 0 .5-.2 1-.5z"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M262.7 287.1c-.4 0-.5 0-.8.6.5-.1.5-.1.8-.6zm0 .6c-1.2 2-1 4.2-.6 6.7h.2c-.2-1.2-.4-2.1-.3-3a6.4 6.4 0 0 1 .8-3.6 11.8 11.8 0 0 0-.1 0zm2-2.2c-.5.2-.7 0-.8.7.5 0 .6-.3.8-.7z"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M263.9 285.3c0 .4.3.6-.2 1.1-.2-.5-.1-.5.2-1z"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M263.5 285.9c.2.3.4.5 0 1-.2-.5-.3-.5 0-1z"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M263.3 286.2c0 .3.3.6-.2 1-.2-.5-.1-.5.2-1z"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M262.9 286.6c.1.3.4.6 0 1-.3-.5 0-.5 0-1z"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M262.6 287c.1.3.4.6 0 1-.2-.4-.3-.5 0-1zm2-1c-.2.1-.6-.1-.9.5.6 0 .6 0 1-.4z"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M264.4 286.5c-.2 0-.6-.2-1 .3.7 0 .7 0 1-.3z"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M264.2 286.8c-.3 0-.7-.2-1 .4.6 0 .6 0 1-.4z"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M263.9 287.3c-.3 0-.6-.4-1 .3.4.1.5 0 1-.3z"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "M263.4 287.6c-.3 0-.4 0-.8.5.5 0 .5 0 .8-.5zm-3.7 3h1.2c.8 0 1.3.2 1.3.4s-.5.3-1.3.3h-1.2c-.7 0-1.3-.2-1.3-.4s.6-.3 1.3-.3z"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    d: "m258.9 290.6-.4.6a.3.3 0 0 0 .2 0h.2l.4-.6h-.4zm1 0-.5.7h.5l.4-.7h-.5zm.9 0-.5.7h.5l.4-.7h-.4zm.9 0-.4.7h.5l.3-.6a.3.3 0 0 0-.2 0h-.2z"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m252.3 286.7.5 2.9.2.2v1l.1.2c.3.5.3 1.2.4 1.7 0 .2 0 0 .4.6h.4l.1.2-.2.3h-.7l-.3-.2v-.2l-.2-.1-.1-.6-.8-1c-.1-.2-.1-.5-.3-.6 0-.2-.2-.2-.3-.3-.5-1.1-1-3.1-1-3.1m-6.9-1.2 2 .4-.6 2.8c-.3.9-.3 1-.2 1.2.2.4.4 1.2 1.2 2.3.2.3.5.3.6.4l.5.4h.6l.1-.2c0-.2-.3-.1-.5-.3-.1-.3-.6-.8-.6-1.2-.3-.8-.2-.8-.2-1.6 0-.4.4-1.3.5-1.8a4.6 4.6 0 0 0 .5-2l-.8-2-.5-.6m-1.8-1.2c-3 1-1.7 3.8-.9 3.8m9.8-8.7.5-1v-.4l-.8 1"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M255.1 279.9h.5v-.3l-.1-.4c-.5-.4-1-.4-1-.7v-.2c0-.2-.9-.3-1-.5l-.5-.2h-.3c-.7 0-1 .8-1.2 1.3 0 0-.2 2.3-.6 3.3a.8.8 0 0 1-.1.3l-.2.2-4.5-.3a4 4 0 0 0-2 .8s-1 .7-1.2 1.7c0 .4 0 .8.2 1.2 1 2.7 2 0 2.3 0h.4c.5 0 1.4 1.6 2.8 2 4.3.9 5.5-1.4 5.4-6.3v-.2l.2-.5v-.5l-.1-.3 1.2-.2.2-.1"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m253 278.5.6-1.2v-.5l-1 1.1v.1m-9.5 8c.3.9.8 1.7.7 2 0 .4-.3.6-.3.7l-.1.1c-.2.1-.2.4-.3.6l-.1.6c0 .8.5 2.4.6 2.4l.3.3v.5l-.1.7v.2l.4.2h.6l-.4-.4a.4.4 0 0 1 0-.3l.3-.4v-.4l-.1-.2a8.8 8.8 0 0 1-.1-1v-1.2l.2-.1.1-.3 1-.6 1-1.1.1-.5a.6.6 0 0 0 0-.2 4 4 0 0 0-.3-1 3.4 3.4 0 0 0-.6-.8m6.3 2c-.6.3-2 .6-2 .9 0 0 0 1.7-.2 2.4l-.3.6-.2.7c-.1.3-.3.6-.3 1v.5l.4.2-.4.2-.7-.3v-.6l.1-.7-.1-.5-.1-1.4v-5m5-5.7c.2.3.5.4 1.3.1.2.1.4.3.7-.2m-.4-.6.3.1c0-.1 0-.2-.1-.1h-.2z"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "m253.6 278.8.1.1c.1.2.4.3.6 0-.3-.3-.5-.1-.6 0z"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M265.7 291.1a2 2 0 0 0 0 .8 2 2 0 0 0 0 .8 2 2 0 0 0 0 .8 2.1 2.1 0 0 0 0 .7c.3.2 1 .2 1.3 0v-.7a2 2 0 0 0 0-.8 2 2 0 0 0 0-.8 2 2 0 0 0 0-.8 2.4 2.4 0 0 0 0-.8 2.2 2.2 0 0 0 0-.8 2.4 2.4 0 0 0 0-.8v-.9a2.5 2.5 0 0 0 0-.8 2.6 2.6 0 0 0 0-.9 2.3 2.3 0 0 0 0-.8 2 2 0 0 0 0-.8 2.7 2.7 0 0 0 0-.9 2.5 2.5 0 0 0 0-.8v-.8a3.1 3.1 0 0 0 0-.9 3.1 3.1 0 0 0 0-.8v-2.5a2.4 2.4 0 0 0-.1-.8v-.8a2.1 2.1 0 0 0 0-.3h-.8v.3c-.1.1-.1.6 0 .8a2.5 2.5 0 0 0 0 .8 2.7 2.7 0 0 0-.1.8 2.9 2.9 0 0 0 0 .8v.9a3.1 3.1 0 0 0 0 .8 3.1 3.1 0 0 0 0 .9 3.5 3.5 0 0 0 0 .8 2.5 2.5 0 0 0-.1.8 2.6 2.6 0 0 0 0 .9c0 .2-.1.5 0 .8a2.4 2.4 0 0 0 0 .8 2.6 2.6 0 0 0 0 .9c-.1.2-.1.5 0 .8a2.8 2.8 0 0 0-.1.9v.8a2.2 2.2 0 0 0 0 .8 2.4 2.4 0 0 0 0 .8z"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M265.7 291.9h1.3m-1.3-.8h1.3m-1.2-.8h1.2m-1.2-.8h1.2m-1.2-.9h1.2m-1.2-.8h1.2m-1.2-.8h1.2m-1.1-.9h1m-1-.8h1m-1-.8h1m-1-.9h1m-1-.8h1m-1-.9h1m-1-.8h1m-1-.8h1m-.9-.9h1m-1-.8h1m-1-.8h.9m-.8-.9h.8m-.9-.7h.9m-1.2 16.5h1.3m-1.3.7a2.5 2.5 0 0 0 1.3 0"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "#007934",
    fillRule: "evenodd",
    stroke: "#e7e7e7",
    strokeWidth: 0.1,
    d: "m268.3 274.2 2.2-.1a14.6 14.6 0 0 0-.9-.3h2.4a5.2 5.2 0 0 0-1-.5c.7-.1 1.7 0 2.3.1l-1-.5 2 .1a2.8 2.8 0 0 0-.9-.5 8.6 8.6 0 0 1 2.7-.1 9.2 9.2 0 0 0-8.6.8 6.5 6.5 0 0 1 1-1.2 2.7 2.7 0 0 0-.7 0l1.3-1a3.1 3.1 0 0 0-.8 0l1.5-1a3.3 3.3 0 0 0-.9 0 5 5 0 0 1 1.7-1.1 4.2 4.2 0 0 0-1 0c.5-.4 1.2-1 2.1-1.4-3.5.4-5.5 3-5.7 5.1-.9-2-3.5-4-7-3.8 1 .3 1.9.7 2.5 1.1a4.6 4.6 0 0 0-1 .1c.7.2 1.5.6 2 1a3.6 3.6 0 0 0-.9.1l1.8.8-.8.1 1.6.8a3 3 0 0 0-.8 0l1.4.8c-2.2-.5-5.4.3-7.9 3.1.4-.3 1.9-.8 2.4-1a4 4 0 0 0-.6.9 8.9 8.9 0 0 1 2.2-1.2 5 5 0 0 0-.4.8l2-1-.5.8 1.8-.7-.5.7 1-.3a6.6 6.6 0 0 0-3 6.1c0-.4.6-1.6.9-2v1a9 9 0 0 1 1-2.1l.1 1 1-2.1v1a14.2 14.2 0 0 1 1.2-2v.8l.3-.6.7-1 .3.4c.2.4.5 1.1.5 1.9a3.4 3.4 0 0 0 .3-1c.3.8.7 2 .7 2.6l.2-1c.3.5.7 1.8.7 2.4l.3-1 .6 2.4c.8-3.1-.4-5.2-2-6.7.4.2 1 .6 1.4 1.1a5.2 5.2 0 0 0-.3-1l1.6 1.6a2.9 2.9 0 0 0-.2-1c.7.5 1.2 1.3 1.6 1.7l-.2-1c.6.5 1.2 1.4 1.4 2l-.1-1.2c.8.7 1 1.4 1.3 1.9 0-2.9-3.3-5.4-6.3-5.7z"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e7e7e7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M267 274.2c3.4-.4 7.6 2.4 7.6 5.7-.2-.4-.5-1.2-1.4-1.9l.2 1.1a6.5 6.5 0 0 0-1.4-1.9l.2 1c-.4-.4-1-1.2-1.6-1.6l.2.8a15.3 15.3 0 0 0-1.6-1.4l.3 1a6 6 0 0 0-1.3-1.2m-2-1.6c-2-1.3-6.2-1-9.3 2.5.4-.3 1.9-.8 2.4-1a4 4 0 0 0-.5.9 8.9 8.9 0 0 1 2.1-1.2 5.1 5.1 0 0 0-.4.8l2-1-.5.8 1.8-.7-.5.7 1-.4"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e7e7e7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M266.4 273.7c-.4-2.4-3.3-5-7.4-4.9 1 .3 1.9.7 2.5 1.1a4.6 4.6 0 0 0-1 .1c.7.2 1.5.6 2 1a3.6 3.6 0 0 0-.9.1l1.8.8-.8.1c.5.1 1.2.5 1.6.8a3 3 0 0 0-.8 0l1.4.8m1.6 1c-2.8.9-5.5 3.6-5.1 7.2 0-.4.6-1.6.9-2v1a9 9 0 0 1 1-2.1l.1 1 1-2.1v1a14.1 14.1 0 0 1 1.2-2v.8c0-.2.9-1.4 1-1.5m-1.7.1a9.3 9.3 0 0 0-.4 1.6m-.6-.9a10.4 10.4 0 0 0-.5 2m-.5-1a9.5 9.5 0 0 0-.6 2"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e7e7e7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M266.5 275.9v-.7",
    className: "fil1 str2"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e7e7e7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m269.4 278.7.1 1.5m-1.1-3.3.1 1.7m-1.1-2.8.2 1.4m5-.5a3.7 3.7 0 0 1 .6 1.3m-2-2.3.8 1.6m-2.1-2 .7 1.3m-11.3-.9a5 5 0 0 1 1.8-1.2m-.2 1c.4-.6.7-1 1.7-1.4m-.2 1.2c.4-.5 1-1 1.8-1.3m-.4 1.3c.5-.5 1-.8 1.7-1m-4-4.4c.8.1 1.7.3 2.3.7m-1.2.4a5 5 0 0 1 2 .5m-1.2.4c.7 0 1.5.3 2.2.7m-1.4.2a4.1 4.1 0 0 1 1.9.6m.8.2a9.1 9.1 0 0 1 9.2-1.2 8.6 8.6 0 0 0-2.7.1c.5.1.9.4 1 .5-.9-.1-1.2-.2-2.2-.1.5.1.8.3 1.1.5a7.8 7.8 0 0 0-2.3-.1l1 .4h-2.4l1 .4-2.3.1m5.1-1.7a6.4 6.4 0 0 0-2.2-.3m1 .7a6.2 6.2 0 0 0-2.7-.3m1.5.7a7.3 7.3 0 0 0-2.7-.2m1.3.7a5.3 5.3 0 0 0-2.1-.1m.9 1.1c.3.3.6.7.8 1.2"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e7e7e7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M266 272.6c.2-2.1 2.2-4.7 5.7-5a9 9 0 0 0-2 1.3h1c-.7.2-1.4.7-1.8 1.2h1c-.6.2-1.2.6-1.5 1h.8c-.4 0-1 .6-1.3.9a2.7 2.7 0 0 1 .7 0c-.5.3-1 .8-1.1 1.2m2.1-4.3c-.5.2-1.1.4-1.6.8m1 .4a4.8 4.8 0 0 0-1.6.5m1 .5c-.6 0-1.1.3-1.6.7m1 .2a3.4 3.4 0 0 0-1.5.8m-.5 2.6a6.4 6.4 0 0 0-.3 1.2m1.3-2.1c2 1.7 4.4 4 3.3 8a8.8 8.8 0 0 0-.6-2.3c0 .4-.2.7-.3 1a7.2 7.2 0 0 0-.7-2.6l-.2 1c0-.6-.4-1.7-.7-2.5a3.4 3.4 0 0 1-.3 1c0-1-.4-1.8-.8-2.2"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m227.5 249 1.4.8.3-.6c.2-.3.2-.5.1-.7 0-.2-.2-.4-.5-.5-.3-.2-.6-.3-.8-.2-.2 0-.3.2-.4.4l-.3.6c0 .1 0 .2.2.3m1.8 1 1.7.9h.3c.1 0 .3-.2.4-.5l.3-.6a.6.6 0 0 0 0-.5.8.8 0 0 0-.2-.2 2 2 0 0 0-.4-.3c-.8-.4-1.4-.3-1.7.4l-.4.7m-2.8-.8a31.7 31.7 0 0 0 .7-1.2c.1-.4.3-.7.6-.9l.6-.4h.9l.5.6.1.8c.3-.3.7-.5 1-.6a1.3 1.3 0 0 1 1 .1c.4.2.7.6.8 1 0 .6 0 1.2-.5 1.9a28 28 0 0 1-.8 1.4l-.3.7a12 12 0 0 0-1.5-1l-1.9-1a12.3 12.3 0 0 0-1.6-.7l.4-.7m9.5-11.5c-.8.6-.7 1.5.4 2.8.5.6 1 1 1.5 1 .5.2 1 0 1.4-.3.4-.3.6-.7.5-1.1a3.3 3.3 0 0 0-.8-1.6c-.6-.7-1.1-1.1-1.6-1.2-.5-.2-1 0-1.4.4m4-.2c.5.6.7 1.4.7 2.1a3 3 0 0 1-1.2 2 3.1 3.1 0 0 1-2.2.9 2.6 2.6 0 0 1-2-1 3 3 0 0 1-.7-2.2 2.9 2.9 0 0 1 1.1-2 3.1 3.1 0 0 1 2.3-1c.7.1 1.4.5 2 1.2m8.5-2.8.3 1a15.2 15.2 0 0 0 2-.7l.4-.1a5.3 5.3 0 0 0 .3.9l-.6.1-2.5.7-.7.2-.4-1.7-.6-2a15 15 0 0 0-.5-1.7l.6-.2.7-.2.4 1.7.6 2m9.8-3 .1-1.8h.8l.7.1-.3 1.8-.2 2-.1 1.8a12 12 0 0 0-.7 0h-.8v-.1l.3-1.7.2-2.2m10.5 5.6a38.2 38.2 0 0 0 3.4-2.8l.4.2.4.2-5 3.8-.5-.3a292.6 292.6 0 0 1 .5-4.7 28.2 28.2 0 0 0 .1-1.4 7.9 7.9 0 0 0 1.4.7 37.1 37.1 0 0 0-.6 4.3m9 4.1a13 13 0 0 0 1.2-1.2l.5.5.5.5-1.4 1.1-1.5 1.5-1.3 1.2a12.3 12.3 0 0 0-.5-.5l-.5-.5 1.4-1.1 1.6-1.5m5.3 10.7a46.2 46.2 0 0 0 1.4-1.5h-2a22.2 22.2 0 0 0 .6 1.5m-1.2-1.5-2 .2a2 2 0 0 0-.2-.4 2.8 2.8 0 0 0-.2-.4 326.8 326.8 0 0 0 6.2 0l.4.6a87.3 87.3 0 0 0-4.2 4.6l-.3-.7a5.7 5.7 0 0 0-.3-.6l1.5-1.4a35.3 35.3 0 0 0-1-1.9",
    fontFamily: "Linux Biolinum",
    fontSize: 100,
    fontWeight: 700,
    letterSpacing: 60,
    style: {
      lineHeight: "125%",
      textAlign: "center"
    },
    textAnchor: "middle",
    wordSpacing: 0
  }), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8a30e",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m261.3 299.3-.9 2.4H258l2 1.5-.7 2.4 2-1.4 2.1 1.4-.7-2.4 2-1.5H262zm9.7-4.1-.8 2.3h-2.5l2 1.6-.7 2.4 2-1.5 2 1.5-.7-2.4 2-1.5h-2.5zm15-26.7-.8 2.4h-2.5l2 1.6-.7 2.3 2-1.4 2.1 1.4-.7-2.4 2-1.4-2.5-.1zm-7.1 19 .8 2.4h2.5l-2 1.5.8 2.4-2.1-1.4-2 1.4.7-2.4-2-1.4 2.5-.1zm5-8.7.9 2.4h2.5l-2 1.6.7 2.3-2-1.4-2.1 1.4.7-2.3-2-1.5h2.5zm-33.1 20.5.8 2.4h2.5l-2 1.5.7 2.4-2-1.4-2.1 1.4.7-2.4-2-1.5h2.5zm-9.8-4.1.8 2.3h2.5l-2 1.6.8 2.4-2.1-1.5-2 1.5.7-2.4-2-1.5h2.5zm-15-26.7.8 2.4h2.5l-2 1.5.7 2.4-2-1.4-2 1.4.6-2.4-2-1.5h2.5zm7.1 19-.8 2.4h-2.5l2 1.5-.7 2.4 2-1.4 2 1.4-.7-2.4 2-1.5H234zm-5-8.7-.9 2.4h-2.5l2 1.6-.7 2.3 2-1.4 2.1 1.4-.7-2.3 2-1.5h-2.5z"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M257.1 264.6v-.5h.1l-.9-.5h-.7l-.8.5v.5h2.3"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M257.1 264.6v-.5h.1l-.9-.5v-.8h-.6v.8l-1 .5h.1v.5h2.3zm.3.7v.2h-2.8v-.2h2.8"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M257.4 265.3v.2h-2.8v-.2h2.8zm-2.6 0v-.6.6-.7h2.5v.1h-.2v.6-.6h.1v.6"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M254.8 265.3v-.6.6-.7h2.5v.1h-.2v.6-.6h.1v.6"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M255.3 265.2v-.4h-.3v.4h.3"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M255 264.9v.2h.2v-.2h-.1m1.9.3v-.4h-.4v.4h.4"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M256.7 264.9v.2h.2v-.2h-.2m.3-.3v-.4h-.4v.4h.4z"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M256.7 264.3v.2h.2v-.2h-.2m-1.4.2v-.3h-.3v.3h.3z"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M255 264.3v.2h.2v-.2h-.1m.8.2v-.3h-.3v.4h.3"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M255.7 264.3v.2h.1v-.2h-.1m.7.2v-.3h-.3v.4h.3"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M256.1 264.3v.2h.2v-.2h-.2"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M256.5 264.4v1h-1v-1h1"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M256.5 264.4v1h-1v-1h1zm-1 .3h1m-.9.6v-.6m.8.6v-.6m.5-.6-.6-.4h-.6l-.6.4h1.8m-1.2-.5h.5m-.3-.2v.2h.2v-.2h-.2m-.3 1v.1m.3 0zm.1 0h.1zm.4 0"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    fillRule: "evenodd",
    d: "M255.8 262.4h.4v.4h-.4v-.4z"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M256 262v.4m-.2-.3h.4"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M253 224.3s-2.6 5.8-1.7 6.4c0 0 3.1-3.5 4-6.3.8-2.8 0-.2 0-.2l-.3-3-2 2.9"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M253 224.3s-2.6 5.8-1.7 6.4c0 0 3.1-3.5 4-6.3.8-2.8 0-.2 0-.2l-.3-3-2 2.9"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M253.5 221.6s-3 6.4-2.3 6.8c0 0 2.5-2.9 3.1-5.1.7-2.3 0-.2 0-.2l.8-4.1"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M253.5 221.6s-3 6.4-2.3 6.8c0 0 2.5-2.9 3.1-5.1.7-2.3 0-.2 0-.2l.8-4.1"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M256.6 220.1s-3 6.4-2.4 6.9c0 0 2.6-2.9 3.2-5.2.7-2.3 0-.1 0-.1l.8-4.1"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M256.6 220.1s-3 6.4-2.4 6.9c0 0 2.6-2.9 3.2-5.2.7-2.3 0-.1 0-.1l.8-4.1"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m295.3 208.7 3.6 2s.8.7-1 .3c-2-.5-6-1.9-13.7-6.8-3.5-2.2-4.6-2.2-4.6-2.2l4.8.2 10.9 6.5z"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m295.3 208.7 3.6 2s.8.7-1 .3c-2-.5-6-1.9-13.7-6.8-3.5-2.2-4.6-2.2-4.6-2.2l4.8.2 10.9 6.5z"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m296.5 207.8 3.5 2s.9.7-1 .3c-2-.4-6-1.8-13.7-6.8-3.4-2.2-.7 1.9-.7 1.9l.6-2.7 11.3 5.3z"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m296.5 207.8 3.5 2s.9.7-1 .3c-2-.4-6-1.8-13.7-6.8-3.4-2.2-.7 1.9-.7 1.9l.6-2.7 11.3 5.3z"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M302.4 209.7s-4.3-.8-5.8-2c0 0 .3.6-1.8-.4 0 0 .8 1.9-5-2.1-6-4-3.9-2-3.9-2l1.7-.4 10 4c1 .3 4.8 3 4.8 3"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M302.4 209.7s-4.3-.8-5.8-2c0 0 .3.6-1.8-.4 0 0 .8 1.9-5-2.1-6-4-3.9-2-3.9-2l1.7-.4 10 4c1 .3 4.8 3 4.8 3z"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m280.1 211.3 1.5 2s-.5 2-5.4-1.8l-4.7-3.4 2.7-.3 6 3.4"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m280.1 211.3 1.5 2s-.5 2-5.4-1.8l-4.7-3.4 2.7-.3 6 3.4"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M273.7 212.3s2.3 3 1.8 3.4c-.5.4-3.2.2-5.2-2.7-1.9-3 0-.2 0-.2l.2-4.7 3.3 4"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M273.7 212.3s2.3 3 1.8 3.4c-.5.4-3.2.2-5.2-2.7-1.9-3 0-.2 0-.2l.2-4.7 3.3 4"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M276 211s2.3 2.8 2 3.2c-.2.5-3.3.2-5.8-2.6-2.5-2.8-.4-3.7-.4-3.7l4.2 2.9"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M276 210.9s2.3 2.9 2 3.3c-.2.5-3.3.2-5.8-2.6-2.5-2.8-.4-3.7-.4-3.7l4.3 3z"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M288.7 209.3s6.3 2.7 1.6 2.5c0 0-9.1-2.5-13.9-6.5l1.4-1.8 10.8 5.6"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M288.7 209.3s6.3 2.7 1.6 2.5c0 0-9.1-2.5-13.9-6.5l1.4-1.8 10.8 5.6"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M292 208.5s3.4 2 3.7 2.8-10.6-2-16.4-6.8l2.6-1.2 10.1 5.2z"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M292 208.5s3.4 2 3.7 2.8-10.6-2-16.4-6.8l2.6-1.2 10.1 5.2z"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M282.1 210.3s2.5 2 2.2 2.3a17 17 0 0 1-9.2-3.5l.4-1.8 6.6 3"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M282.1 210.3s2.5 2 2.2 2.3a17 17 0 0 1-9.2-3.5l.4-1.8 6.6 3"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M286.3 210.2s2.4 1.7 2 1.8c-.6.2-2.5 1.7-11.5-3.6l-1.1-.6 1.4-2.2 9.2 4.4"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M286.3 210.1s2.4 1.8 2 2c-.6.1-2.5 1.6-11.5-3.7l-1.1-.6 1.4-2.2 9.2 4.5z"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M277 205.2s3 2.6 2.6 3c-.4.4-3.9-.4-5.5-1.6-1.5-1.1-2.6-2.6-2.6-2.6l3.3-.7 2.2 2z"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M277 205.2s3 2.6 2.6 3c-.4.4-3.9-.4-5.5-1.6-1.5-1.1-2.6-2.6-2.6-2.6l3.3-.7 2.2 2z"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m273.5 200.8 5.4 3.2s4.4 3.1 3.9 3.4c-.5.2-4-.8-6.4-2.2a29.5 29.5 0 0 1-5.3-4.2"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m273.5 200.8 5.4 3.2s4.4 3.1 3.9 3.4c-.5.2-4-.8-6.4-2.2a29.5 29.5 0 0 1-5.3-4.2"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M270.1 216s1 2.5.4 2.7c-.6.2-2-.2-3.3-2.5-1.1-2.4 1-1.4 1-1.4l2 1.1z"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M270.1 216s1 2.5.4 2.7c-.6.2-2-.2-3.3-2.5-1.1-2.4.9-1.3.9-1.3l2 1z"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M271.9 214.3s1.5 2.4 1.2 2.7c-.4.3-2.3 1.2-4.5-2s2.2-2.5 2.2-2.5l1 1.8z"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M271.9 214.3s1.5 2.4 1.2 2.7c-.4.3-2.3 1.2-4.5-2s2.2-2.5 2.2-2.5l1 1.8z"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M267.4 203s5.1 10 4.7 10.5c-.4.5-2.5 0-3.6-2.6a53.3 53.3 0 0 1-2-6l1-1.8z"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M267.4 203s5.1 10 4.7 10.5c-.4.5-2.5 0-3.6-2.6s-2-6-2-6l1-1.8z"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M273.4 205.6s4.2 3.6 3.4 4c-1 .5-2.6-.1-5.1-2.6-2.5-2.5 1.6-1.6 1.6-1.6"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M273.4 205.5s4.3 3.7 3.4 4.2c-1 .5-2.6-.2-5.1-2.7-2.5-2.5 1.7-1.5 1.7-1.5z"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M271.3 205.7s3 5.6 2.7 6c-.4.6-2.7-1.3-3.8-2.7s-2-3.5-2-3.5"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M271.3 205.7s3 5.6 2.7 6c-.4.6-2.7-1.3-3.8-2.7s-2-3.5-2-3.5"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M248.4 217.2v3.5c.1.2 1.9.3 2-2.2 0-2.5-.4-2.6-.4-2.6l-1.6 1.2"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M248.4 217.2v3.5c.1.2 1.9.3 2-2.2 0-2.5-.4-2.6-.4-2.6l-1.6 1.2"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M249.4 213.2s-1.1 3.7 0 4.4c1.1.8 2-3.6 2-4.6.1-1-2 .2-2 .2"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M249.4 213.2s-1.1 3.7 0 4.4c1.1.8 2-3.6 2-4.6.1-1-2 .2-2 .2z"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M250.2 218s.3 3.4.9 3.5c.6.2 1.7-1 1.7-1.9 0-.9-1.1-3-1.1-3l-1.5 1.2"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M250.2 218s.3 3.4.9 3.5c.6.2 1.7-1 1.7-1.9 0-.9-1.1-3-1.1-3l-1.5 1.2"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M250.3 213.8s-1.2 3.7 0 4.4c1 .8 2-3.6 2-4.6 0-1-2 .2-2 .2z"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M250.4 207.8s-1.8 1.8-1.7 2.8c0 1 2.5-1.3 2.8-1.8.2-.4-1.1-1-1.1-1"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M250.4 207.8s-1.8 1.8-1.7 2.8c0 1 2.5-1.3 2.8-1.8.2-.4-1.1-1-1.1-1z"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M249.2 206.8s-1.4 2.6-1 3.3c.3.8 1.7-.5 2.3-1.4.6-1-1.3-1.8-1.3-1.8"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M249.2 206.8s-1.4 2.6-1 3.3c.3.8 1.7-.5 2.3-1.4.6-1-1.3-1.8-1.3-1.8z"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M268.3 203.5s2.1 4.1 1.5 4.3c-.6.2-1.5-.8-2.4-2-.9-1.2.9-2.3.9-2.3"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M268.3 203.5s2.1 4.1 1.5 4.3c-.6.2-1.5-.8-2.4-2-.9-1.2.9-2.3.9-2.3z"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M268.3 211.9s.8 3.4.1 3.7c-1.3.7-2-2.4-2.2-3.6 0-1.2 2.1-.1 2.1-.1zm-2.7 5.4s.2 2.6-.2 2.8c-.3.3-1.2.3-2.3-1.8-1-2.2-.5-1.4-.5-1.4l2.5-1.2.5 1.4"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M268.1 216.7s.3 2.8-.2 2.8c-.6.1-2-.8-2.7-2.4-.7-2 2.6-1.4 2.6-1.4l.3 1z"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M265.6 208.4s2.7 6.2 2.3 7.1c-.9 1.8-3.4-3.8-4.2-6-.8-2.4 1.9-1.1 1.9-1.1z"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M264.3 209.4s3.8 7 2.1 7c-1.5.2-4.5-5-5-6.1-.5-1.2 2.9-.9 2.9-.9z"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M264 210.8s1.9 6.6.7 6c-1.2-.5-2.7-5.5-2.9-6.6-.2-1 2.2.7 2.2.7zm6.6-9.4s3 4.5 2 4.6c-1 .1-4.4-3-4.4-3.5s2.4-1 2.4-1z"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M268.8 201.7s3.7 5 2.6 5.2c-1.1.3-1.2-.5-1.2-.5s-3-2.7-3.1-3.3c-.3-.7 1.6-1.5 1.6-1.5m3.8.1s2.5 2.6 1.8 3.5c-.6 1-4.2-3.3-4.6-3.8-.5-.6 3 .2 3 .2m-6.4 3.8s4.1 8 3.3 8.7c-.7.8-5.3-6-5.4-7-.2-.9 2.2-1.9 2.2-1.9"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M264 206s1.6 2.6 1.5 4c0 1.3-2.5-2-2.7-2.6-.2-.6 1.2-1.3 1.2-1.3z"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M267.3 204.8s1.3 2.6.9 3.3c-.4.8-2.1-1.5-2.7-2.4-.6-1 1.8-1 1.8-1z"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M261.4 207.3s2 2.2 2 3.4c-.2 1.2-3-1.7-3.3-2.3-.3-.5 1.3-1 1.3-1z"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M274.3 201s3 2.6 2.6 3c-.5.5-4.6-2.4-5.2-3-.6-.6 2.6 0 2.6 0z"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m271.8 200.7 2.3 2s2.2 1.5 1.8 1.9c-.3.3-3.8-1.2-4.4-2-.6-.6-.5-1.4-.5-1.4l.8-.5zm7.7.7s9 3.6 8.6 4.5c-.3.8-9.3-3-10.8-4s2.1-.6 2.1-.6"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M279.9 202.5s6.7 3.8 5.9 4.1c-.8.4-5.6-.9-8-2.6a38.4 38.4 0 0 1-3.6-2.6l3-.7 2.7 1.8zm-16.6 4.6s1.3 2.6 1 3.3c-.5.8-1.7-.6-2.3-1.5-.6-1 1.3-1.8 1.3-1.8zm.3 5.8s1.1 3.7 0 4.4c-1.2.7-2-3.7-2-4.7s2 .3 2 .3z"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M258.4 206.7s3.8-1.6 4.5-1.5c0 0 .7-.2 1.1-.5l1.4-1.1s-.6-4.5 4.1-4l12.3 1.2a48 48 0 0 1 7 2c1 .5 8.1 3.7 9.6 4.2.8.3 2.7 1.5 4.1 2.4 1 .7 0 .2 0 .2s-11.5-6-15.5-6.9c-1-.2 0 1.2 0 1.2l-3.6-1.5a6.3 6.3 0 0 0-3-.6 6.2 6.2 0 0 1-2.4-.3c-.6-.2-4-.3-4.7-.4a7.8 7.8 0 0 1-1-.2l.2.4-1.7-.3-.5.8s-1.6.3-1.7-.2c-.2-.6-1 2.3-1.4 3.2-.4.8-2 .8-2.5 1.3a5.4 5.4 0 0 1-1 1c-.2.2-1.5.9-1.9.9l-3 .2-.7-1 .3-.5zm5 10.6s0 3.3-.2 3.6c-.2.2-1.8.1-1.8-2.3 0-2.5.4-2.6.4-2.6l1.6 1.2"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M263.8 214.8s-.4-1.4-.6-1.6c-.2-.2.1-.4.1-.4s-.6-1.5-1-1.7c-.3-.3.1-.5.1-.5s-.6-1-1-1.2c-.5-.3 0-.4 0-.4s-.6-1.3-1.7-2c0 0-.7-.7-1.4-1-.8-.1-2.6-.3-4.9-.3a4 4 0 0 0-3.3 1.7l-.2 1.9.4-.2-.5 2.3c-.1.6.4 1.5.4 2.6a11 11 0 0 0 .9 4.2l.1.3c.1-.2.4.6.6 1 0 0 .1 1.1.2.7.1-.2.5.6.7 1.2 0 .2.5 1.5.5.9 0-.7.4 1.3.4 1.6l.6-.8.2 1 .5-.1-.2.8s1.3-1 1.3-1.4l.1-.7.4-.4.7-1s1.6 1.2 1.8 1.7l.3.8.4-.4.4 1 .2-.5.2.6.2.4c.1 0 .4.1.8-.7.7-1.1.7-2 .7-2.2 0-.2.3.4.3.4s.6-1.1.5-1.8c0-.7.4-.5.4-.5V218c-.1-.5.3-.4.3-.4s-.1-2.2-.3-2.4c0-.3.4-.3.4-.3z"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M260.6 209.8c.3 0 .5.4.6.7v-.1c-.1-.3-.3-.7-.6-.8v.2m.3 1.3c.6.5.6 1.2.6 2 0 0 0 .1 0 0 0-.8 0-1.6-.6-2.1v.1m1.2.7a3.2 3.2 0 0 1 .4 1.8c0-.7 0-1.3-.4-2v.2m.4 2.6-.1 1.1a.5.5 0 0 0 0 .2 11.8 11.8 0 0 0 .1-1.3m-.4 2v.7a4.1 4.1 0 0 0 0-.8m-.7-2.4a15.3 15.3 0 0 0 0 1.2 14.3 14.3 0 0 1 0-1.2m1.5 2.4a1.2 1.2 0 0 1 .3.6 1.2 1.2 0 0 0-.3-.7v.1m-.1-2.8.4.5a3.3 3.3 0 0 0-.4-.6v.1m-1.5 2.1a6.4 6.4 0 0 1-.1 1.1.4.4 0 0 0 0 .1 6.9 6.9 0 0 0 0-1.2m-.7.8a5.7 5.7 0 0 1 0 1.1 6.6 6.6 0 0 0 0-1.2v.1"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M246.1 207.3s-.9 3.4-.2 3.7c1.3.7 2.2-2.3 2.3-3.5.1-1.3-2-.2-2-.2"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M246.1 207.3s-.9 3.4-.2 3.7c1.3.7 2.2-2.3 2.3-3.5.1-1.3-2-.2-2-.2z"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M248 207.3s-1.6 1.7-1.6 2.7c0 1 2.5-1.3 2.8-1.8.2-.4-1.1-1-1.1-1"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M248 207.3s-1.6 1.7-1.6 2.7c0 1 2.5-1.3 2.8-1.8.2-.4-1.1-1-1.1-1z"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M218.7 207.5s-3.5 1.8-3.8 2.5c-.4.8 10.7-1.1 16.7-5.4l-2.4-1.4-10.5 4.3z"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M218.7 207.5s-3.5 1.8-3.8 2.5c-.4.8 10.7-1.1 16.7-5.4l-2.4-1.4-10.5 4.3z"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M222.9 208.2s-6.5 2.4-1.8 2.5c0 0 9.3-2 14.2-5.7l-1.2-1.9-11.1 5"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M223 208.2s-6.6 2.4-1.9 2.5c0 0 9.3-2 14.2-5.7l-1.2-1.9-11.2 5z"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M232.4 201.7s-6.8 3.5-6 3.9c.7.4 5.6-.7 8.1-2.3 2.6-1.6 3.6-2.5 3.6-2.5l-3-.8-2.7 1.7z"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M232.4 201.7s-6.8 3.5-6 3.9c.7.4 5.6-.7 8.1-2.3 2.6-1.6 3.6-2.5 3.6-2.5l-3-.8-2.7 1.7z"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M229.8 209.4s-2.4 2-2.1 2.2c.3.3 5.3-.5 9.2-3.6l-.5-1.8-6.6 3"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M229.8 209.4s-2.4 2-2.1 2.2c.3.3 5.3-.5 9.2-3.6l-.5-1.8-6.6 3"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M225.6 209s-2.3 1.9-1.8 2c.5.2 2.5 1.6 11.2-4.2l1-.6-1.5-2.2-9 4.9"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M225.6 209s-2.3 1.8-1.8 2c.5.2 2.5 1.6 11.2-4.2l1-.6-1.5-2.2-8.9 5z"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M223.8 202.2A72.3 72.3 0 0 0 209 210l19-7.6m12 11.4s-1.6 2.4-1.3 2.7c.3.3 2.3 1.2 4.6-1.9 2.2-3-2.2-2.6-2.2-2.6l-1.1 1.8z"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M240 213.8s-1.6 2.4-1.3 2.7c.4.3 2.3 1.2 4.6-1.9 2.2-3.1-2.2-2.6-2.2-2.6l-1.1 1.8z"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M241.7 215.5s-1 2.5-.5 2.8c.6.2 2.1-.2 3.4-2.5s-.6-1-.6-1l-2.3.7zm-3.5-3.8s-2.4 3-1.9 3.4c.5.4 3.2.3 5.3-2.6 2-2.8 0-.1 0-.1l-.6-2.6-2.8 1.8"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M241.7 215.5s-1 2.5-.5 2.8c.6.2 2.1-.2 3.4-2.5s-.6-1-.6-1l-2.3.7zm-3.5-3.8s-2.4 3-1.9 3.4c.5.4 3.2.3 5.3-2.6 2-2.8 0-.1 0-.1l-.6-2.6-2.8 1.8"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M236 210.3s-2.4 2.7-2.2 3.2c.3.4 3.4.3 6-2.4 2.6-2.8.5-3.7.5-3.7L236 210"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M236 210.3s-2.4 2.7-2.2 3.2c.3.4 3.4.3 6-2.4 2.6-2.8.5-3.7.5-3.7L236 210"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m231.8 210.5-1.5 2s.5 1.9 5.5-1.6l4.8-3.2-2.7-.5-6.1 3.1"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m231.8 210.4-1.4 2s.4 2 5.4-1.5l4.8-3.2-2.7-.5-6 3.2z"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m215.7 207.4-3.3 1.5s-.7.6 1.2.7a41.8 41.8 0 0 0 17.6-7.7l-2.5-1-13 6.5z"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m215.7 207.4-3.3 1.5s-.7.6 1.2.7a41.8 41.8 0 0 0 17.6-7.7l-2.5-1-13 6.5z"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M210.2 209.5s4.6-.5 6.4-1.7c0 0-.3.5 2-.4 0 0-1.2 2.1 5.7-2 7-4.3 0-.2 0-.2l7.8-4.4-.5-.8-15.7 6.6a58 58 0 0 0-5.7 2.9"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m224.4 205.3 7.6-4.5-.4-.8-15.7 6.6c-1.1.3-5.7 2.9-5.7 2.9s4.6-.5 6.4-1.7c0 0-.3.5 2-.4 0 0-1.1 2 5.8-2.1z"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M243.8 215.4s-.5 3.7 0 3.8c.6.1 2.1-1 2.8-3.3.6-2.2-2.5-2-2.5-2l-.5 1.4"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M243.8 215.4s-.5 3.7 0 3.8c.6.1 2.1-1 2.8-3.3.6-2.2-2.5-2-2.5-2l-.5 1.4"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M246.2 217s-.3 2.6 0 2.9c.4.2 1.3.3 2.4-1.8l.6-1.3-2.5-1.4-.5 1.4"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M246.2 217s-.3 2.6 0 2.9c.4.2 1.3.3 2.4-1.8l.6-1.3-2.5-1.4-.5 1.5z"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M246.8 212.3s-2 4.3-.8 4.3c1.1 0 2.6-3.3 2.9-4 .2-.8-2-.3-2-.3"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M246.8 212.3s-2 4.3-.8 4.3c1.1 0 2.6-3.3 2.9-4 .2-.8-2-.3-2-.3z"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M246.7 212.3s-.8 4.7.3 4.3c1-.4 1.7-4 1.7-4.8 0-.7-2 .4-2 .4"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M246.7 212.3s-.8 4.7.3 4.3c1-.4 1.7-4 1.7-4.8 0-.7-2 .4-2 .4z"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M248.3 212.7s-1.2 3.7 0 4.5c1 .7 2-3.7 2-4.7s-2 .2-2 .2"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M248.3 212.7s-1.2 3.7 0 4.5c1 .7 2-3.7 2-4.7s-2 .2-2 .2z"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M243.7 211.5s-1.2 3.4-.5 3.8c1.3.6 2.4-2.4 2.5-3.5.2-1.3-2-.3-2-.3zm-8.5-7s-3 2.5-2.7 2.9c.4.4 4-.3 5.5-1.4 1.6-1 2.2-1.6 2.2-1.6l-2.7-1.7-2.3 1.8z"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M237.9 202s-2 1.5-1.6 1.9c.3.4 3.8-1 4.5-1.7.6-.7.6-1.4.6-1.4l-3.5 1.1z"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M239.9 201.7s-2.7 2.2-2 3c.6.7 4.3-2.8 4.8-3.2.5-.5-3.1 0-3.1 0"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m238.7 200.7-5.3 2.5s-4.5 3-4 3.2c.4.3 3.9-.6 6.4-1.9 2.5-1.2 5.2-3.3 5.2-3.3m-.8 2.4s-5.8 4.9-5 5.4c1 .5 4.8-1.6 7.4-4"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M240.9 205.2s-3.3 5.5-2.9 6c.4.6 2.7-1.3 3.9-2.7 1.2-1.3 2.1-3.4 2.1-3.4"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M242.8 205.7s-3.6 6.5-3.2 7c.4.6 2.5.2 3.7-2.4 1.2-2.6 1.1-4.2 1.1-4.2l-1.6-.4z"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M244.8 206s-3.9 8-3.1 8.8c.7.8 5-6 5.3-7 .3-1.8-2.2-2-2.2-2m-8.2-5.2s-3.6 1.7-2.8 2c.7.4 4-1 4.4-1.2.5-.2-1.6-.8-1.6-.8z"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M237.1 201.2s-2.2 1.7-1.7 2.2c.4.4 3.7-1.4 4.4-2 .6-.5-2.7-.2-2.7-.2zm4.6.1s-3 4-2.1 4.2c1 .1 4.4-2.6 4.4-3 0-.5-2.3-1.2-2.3-1.2z"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M243 202.2s-3.2 4-2.3 4.3c1 .2 1-.4 1-.4s2.5-2.1 2.7-2.6c.2-.6-1.3-1.3-1.3-1.3"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M244 203.2s-2.3 4-1.7 4.2c.6.2 1.5-.7 2.5-2 1-1.1-.8-2.2-.8-2.2z"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M244.6 205s-1.4 2.5-1 3.3c.3.8 1.7-.6 2.3-1.5.6-.9-1.3-1.8-1.3-1.8zm.6 7s-1 3.4-.3 3.7c1.4.7 2.2-2.3 2.3-3.5.2-1.3-2-.2-2-.2z"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M251.4 207.4s-1-.3-1.6-.3c0 0-2-1.6-3-1.8-1.2-.1-.3-.1-.3-.1s0-2.6-.4-2.8c0 0-.2-2.7-1.8-2.9-1.7-.2-5.5.2-6.2 0-.6-.3-2.7-1.2-6.7-.1-4 1-12 4.6-12.3 4.7-.4.1 9-2 11.8-3.2 0 0 2.6-.2 3.4-.5 0 0-3 1.5-.2.9 2.8-.7 2.2 0 2.2 0s-.3.6 1.3.2c1.6-.3 1.6 0 1.6 0s1.8.7 3.2-.2c0 0 .7 2.6 1.6 3 0 0 1.1 2.2 3.4 2.7l1.3.9 1.3.4 1.3-1"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M232.8 200.6s-9 3.2-8.7 4c.3 1 9.4-2.4 10.9-3.4 1.4-.9-2-.7-2-.7"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "m257.9 207.6.6.2a1.6 1.6 0 0 0-.4-.4l-.7-.3.1.2.4.3m-7 6.8c0 .3 0 .6.2.8v-.1c-.1-.3-.1-.6-.3-.8v.1m1.3-7 .9-.1v-.2c-.3 0-.6 0-1 .2v.1m1.9-.1.9-.2v-.1a2 2 0 0 0-1 .2m-3 1.7h-.1a.3.3 0 0 0 0 .2v-.2m-.2 4.9v.7a.3.3 0 0 0 0-.1 4.3 4.3 0 0 1 0-.6c0-.1 0-.1 0 0"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fill: "#bd8759",
    d: "m252.4 228.2-1.2 1.1a4 4 0 0 0-.1.7s.9 0 .8.4c0 0 .3.2.8-.9.4-1 .9-1.6 1.2-1.5.3 0 .8.3 1 .6.2.2.5.4.9.3 0 0-.4-.6-.2-.8h.7s-.4-.8-1-1c-.7 0-1.2-.2-1-.5l1-2.6-1.1-1.6-.5 1.4.2 1c0 .3-1 2.2-1 2.3l-3 1.2c-.2 0-.8.8-.8.8v.5s.3-.3.5-.1c0 0 .2-.4.5-.3l.2.2.5-.4.1-.1.6-.2"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m252.4 228.2-1.2 1.1a4 4 0 0 0-.1.7s.9 0 .8.4c0 0 .3.2.8-.9.4-1 .9-1.6 1.2-1.5.3 0 .8.3 1 .6.2.2.5.4.9.3 0 0-.4-.6-.2-.8h.7s-.4-.8-1-1c-.7 0-1.2-.2-1-.5l1-2.6-1.1-1.6-.5 1.4.2 1c0 .3-1 2.2-1 2.3l-3 1.2c-.2 0-.8.8-.8.8v.5s.3-.3.5-.1c0 0 .2-.4.5-.3l.2.2.5-.4.1-.1.6-.2"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fill: "#bd8759",
    d: "M259.3 223.1v2.3c0 .4 0 .9-.2 1.2-.2.3-.4.5-.7.5s-1.2 0-1.4.3a5.4 5.4 0 0 1-.3.5s.6-.4.6 0c.1.3-.2.5-.2.5s.5.1 1-.1c.4-.3.7-.4.9-.4.2 0 .4.3.4.3v1c0 .5 0 1.3.4 1.3 0 0 .1-.4.3-.5.2 0 .6.4.5.6v-1.4l-.3-1s1.4.5 1.5.7l.6.4c.1 0 0-.5.3-.5h.3s-.4-.9-1-1.2l-1.3-.5c-.2-.3-.3-.6-.3-1v-3l-1-.2"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M259.4 223v2.4c0 .4 0 .9-.3 1.2-.2.3-.4.5-.7.5s-1.2 0-1.4.3a5.2 5.2 0 0 1-.3.5s.6-.4.6 0c.1.3-.2.5-.2.5s.5.1 1-.1c.4-.3.7-.4.9-.4.2 0 .4.3.4.3v1c0 .5 0 1.3.4 1.3 0 0 .1-.4.3-.5.2 0 .6.4.5.6v-1.4l-.3-1s1.4.5 1.5.7l.6.4c.1 0 0-.5.3-.5h.3s-.4-.9-1-1.2l-1.3-.5c-.2-.3-.3-.6-.3-1v-3l-1-.1z"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcddde",
    d: "M250.7 210.5s-.1-1.4.3-1.6c0 0 .1-1.2 1.8-1 0 0 .6-1 1.5-.5 0 0 .8-.4 1.3-.2a5 5 0 0 1 1.2.8s.7-.1 1 .1c.4.3.2 1.2.2 1.2s.9.6 1 1.2c0 .5 0 .7-.2.9 0 0 .4.3.3.7 0 .4-.4 1-.5 1s0 1.1-.3 1.5c-.4.4-.7.4-.9.5-.1 0-.5.6-1 .7-.3 0-.8-.6-.9-.8 0-.2-.5-.4-.5-.4s-1.2 1.3-2 1a2 2 0 0 1-1.2-1l-.3-1s-1-.5-.8-1c0-.5.4-1 .4-1l-.4-1.1z"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M253.7 226a.3.3 0 0 1-.3 0m.7-1a.8.8 0 0 1-.4 0m0 .6h.2m-1 1.5a.3.3 0 0 0 .1.1m6.9-1 .5.1m-.2-.6h-.4m.4-.6a1 1 0 0 1-.4 0m-.1 2 .4.1m-.4.5a.2.2 0 0 1 .2 0m0 1.7a.4.4 0 0 1 .2 0m-5.4-2.2a.4.4 0 0 0-.3.3m1.1-.2c-.2.1-.3.3-.3.5m-4.9.4.5.3m10.5-1a.4.4 0 0 0-.2.3m.8 0a.2.2 0 0 0-.1.1"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9c0b9",
    d: "m249 229.4.6-.1s-.3.7-.2 1c0 0-.6-.4-.4-.9"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m249 229.4.6-.1s-.3.7-.2 1c0 0-.6-.4-.4-.9z"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9c0b9",
    d: "M251.3 229.8s-.7 1.1.1 1.7c0 0 0-1 .6-1.3l-.8-.3z"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M251.3 229.8s-.7 1.1.1 1.7c0 0 0-1 .6-1.3l-.8-.3z"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9c0b9",
    d: "m255.6 228.8-.2-.6.2-.2h.6s.4.9 0 1.3c0 0 0-.5-.2-.5h-.4"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m255.6 228.8-.2-.6.2-.2h.6s.4.9 0 1.3c0 0 0-.5-.2-.5h-.4z"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9c0b9",
    d: "M257 227.6h.4l.1.4v.3l-.4.2s-.5-.2-.4.5c0 0-.2-1.2.3-1.4"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M257 227.6h.4l.1.4v.3l-.4.2s-.5-.2-.4.5c0 0-.2-1.2.3-1.4z"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9c0b9",
    d: "m259.7 230.3.4-.5.4.3-.2 1.2v.1l-.3-.3-.3-.8"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m259.7 230.3.4-.5.4.3-.2 1.2v.1l-.3-.3-.3-.8z"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9c0b9",
    d: "M262.3 229.1s.7.8.6 1c0 0 .7-.6-.2-1.5l-.4.5z"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M262.3 229.1s.7.8.6 1c0 0 .7-.6-.2-1.5l-.4.5z"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M259.5 209c.1 0 .2 0 .3.2v-.1c0-.2-.2-.3-.3-.3v.1m.1 2.3.5.7v-.1a1.8 1.8 0 0 0-.5-.8v.2m-.4-1.7.5.6v-.1l-.5-.6v.1m.5 3.7-.1 1a2 2 0 0 0 .1-1.1.4.4 0 0 0 0 .1m.5 1.2v-.1m2 4.1a5.1 5.1 0 0 1 .1 1.4l-.1-1.5v.1m-.3 1a7.9 7.9 0 0 1-.4.9v.1a7.8 7.8 0 0 0 .4-1m-11-3.2.8 1.3v-.1l-.8-1.3v.1m2 0c-.3.1-.4-.3-.6-.4v.2c.2 0 .3.4.5.4v-.1m-1 1.8.5 1-.5-1.1v.1m1.2.5c.3.2.5.5.6.8v-.1a2.9 2.9 0 0 0-.6-.9v.2m0 1.3.3.7v-.2l-.4-.7v.2m1.2.2a3 3 0 0 1 .1.8 3.5 3.5 0 0 0 0-.9s-.1.1 0 .1m-.6 1.1c0 .4.2.7.4 1v-.1l-.4-1a.4.4 0 0 0 0 .1m.3-4.6.9.2a8.6 8.6 0 0 1-.9-.4v.1m.2 1.3 1 .5v-.2l-1-.5v.2m.3 1.3.6.6v-.1a4.8 4.8 0 0 1-.6-.6v.1m.4 1.7.3.8a.3.3 0 0 0 0-.1 1.9 1.9 0 0 0-.3-.8v.1m1-4.2.1.5v-.1a10.8 10.8 0 0 1 0-.5.3.3 0 0 0 0 .1m2.4-1-.2.5v.2a3.8 3.8 0 0 0 .3-.6m1-.1v.8a.4.4 0 0 0 0 .1 4.4 4.4 0 0 0 0-1m.2 1.7a3 3 0 0 1 0 .7.6.6 0 0 0 0 .1 4 4 0 0 0 0-.8m.8 1.5a1.4 1.4 0 0 1-.5.8v.2c.3-.3.5-.6.5-.9a.5.5 0 0 0 0-.1m-2.6-1.5-.2.4v.1l.2-.4v-.1m.3 2a2 2 0 0 1-.3.4v.2a2 2 0 0 0 .3-.4v-.1m-.9 1c-.3-.4-.5-.8-.3-1.3v-.1c-.2.5-.1 1.1.3 1.5v-.1m-1.2-1.1v.7a2 2 0 0 0 0-.9.3.3 0 0 0 0 .2m2.8 1.3-.3.7v.1l.3-.7m1.8.7-.5.7v.2a9.7 9.7 0 0 0 .5-.8v-.1m.8.9a18 18 0 0 0 0 .1.5.5 0 0 0 0-.1m1.1-1.7v.5c0 .1 0 0 0 0v-.5c0-.1 0 0 0 0m-11.8-5.2v1.4s.1-.1 0-.1v-1.2"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M254.7 209.4c.8-.7 1.8-1.4 2.9-1.1v-.2c-1-.2-2.1.5-2.9 1.2v.1m3.7.9c-.8-.6-2-.7-2.8-.1v.1c.7-.6 2-.4 2.8.1v-.1m-3 1.1a6 6 0 0 1 .6 3.2.5.5 0 0 0 0 .1c.2-1.2-.2-2.3-.5-3.4v.2m-1.2.6c.2 1 0 2 0 3v.1c0-1 .2-2.2 0-3.2m1.6-.7c1 .3 2 1 2.5 1.8v-.1a4.1 4.1 0 0 0-2.5-1.8v.1m-.9 1.4-.1 1.9v.1c.2-.6.1-1.3.1-2m1.6-.1c.6.5 1.1 1.3 1.2 2a3.4 3.4 0 0 0-1.2-2.2v.2m-4.6 1.7c.2-.3.4-.6.8-.8v-.1c-.4.1-.6.5-.8.8m1.5-5.3a2 2 0 0 0-1-1.2v.1c.4.3.8.7 1 1.2v-.1m-1 0a3.7 3.7 0 0 0-1.6-.3v.1c.6 0 1.1 0 1.7.3v-.1m1.6-.1c0-.5 0-1-.5-1.4v.1c.4.3.6.7.5 1.2m2 .7c.5-.2 1-.2 1.5-.2v-.1c-.5 0-1 0-1.5.2v.1m.9 1.4c.7 0 1.3.4 1.8 1v-.3a2.8 2.8 0 0 0-1.8-1v.3m-3.4 2c-.2.8 0 1.7-.9 2v.3c.9-.3.7-1.3 1-2v-.3"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M255.5 212.3c.3.7.7 1.5.5 2.4a1 1 0 0 0 0 .2c.2-1-.2-2-.5-2.9v.3m1-.2a2 2 0 0 1 1.6 1.6v-.1a1 1 0 0 0 0-.2 1.8 1.8 0 0 0-1.5-1.5v.2m0 1.1c0 .7.3 1.3 0 2v.2c.3-.8.1-1.6 0-2.4a1 1 0 0 0 0 .2m-.4-2.7c.8-.2 1.6-.3 2.3.3v-.3c-.7-.6-1.5-.4-2.3-.3v.3m-1.5-1.6c0-.7.7-1.2 1.3-1.4v-.3c-.7.2-1.2.7-1.3 1.4a1 1 0 0 0 0 .2m-.8.5c0-.8-.3-1.4-.6-2v.2c.2.6.6 1.2.6 1.8 0 .2 0 0 0 0m-.7.4a2 2 0 0 0-1.1-1.4v.2c.5.3 1 .8 1.1 1.4a.8.8 0 0 0 0-.2m-1-.3a3 3 0 0 0-1.3-.6v.2c.5.1.9.4 1.3.6v-.2m2.3 3.1c0 .7.2 1.4-.2 2v.3c.5-.7.3-1.6.3-2.5v.2"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M255.3 212.1c.3.7.6 1.4.5 2.1v.2c0-1-.2-1.7-.5-2.5v.2m.6-1c.7.3 1.3.5 1.8 1v-.2a3.8 3.8 0 0 0-1.8-1v.3m-1.8-1.5a16 16 0 0 0 .1-1.8c0-.2 0-.2 0 0 0 .5 0 1-.2 1.6v.2m-1.2-.4a6 6 0 0 1-1.3-.9v.3l1.3.9v-.3m-.2 3.5c-.3.2-.5.5-.7.9v.2l.7-.8v-.3m.9.6c0 .4-.3.8-.6 1.2v.2c.4-.4.6-.8.6-1.4 0 0 0-.2 0 0m2.3-3.8c.4-.7 1.3-.7 2-1v-.2c-.7.2-1.6.2-2 .9v.2m-4.5 0a2.2 2.2 0 0 1-.4-.2v.2l.4.2v-.2m.1 3.3a1 1 0 0 0-.4.2v.3l.4-.2v-.2a.8.8 0 0 0 0-.1m.6.1-.7.7v.2l.7-.7v-.2m1.1.3c-.2.6-1 1.3-.4 2v-.3c-.4-.5.2-1 .4-1.4v-.3m.8 0-.2 1.8a1 1 0 0 0 0 .3 10.5 10.5 0 0 0 .2-2.1m2-.7c.5.6.9 1.2 1 2v-.3a5.7 5.7 0 0 0-1-2v.3m.2-.5c.8.5 1.6 1 2.1 1.9v-.3c-.5-.8-1.3-1.3-2-1.9v.3"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M256.6 211h.8l.6.5c.2.1.5.2.6.4.3.3.3.7.3 1a.8.8 0 0 0 0-.2l-.1-.8-.5-.5-.8-.5c-.3-.2-.6-.2-1-.1v.2"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m258.4 212.5.3.8v-.2l-.3-.7v.1m-2.1-3.8 1.6-.4v-.3l-1.6.4v.3m-2.2.3a2.4 2.4 0 0 1 .4-.8l.4-.9v-.3l-.4.8c0 .3-.3.6-.4 1v.2m-1.8 5 .1 1.3v-.3a1.5 1.5 0 0 1 0-.8v-.2m1 .8c-.2.2-.2.6 0 1v-1m.8-.5-.2.8v.2l.2-1s0-.1 0 0m0-1.5v.5-.6.1m-.3.2a.9.9 0 0 1 0 .1.8.8 0 0 0 0 .3v-.7.3m-.6-.2a3.7 3.7 0 0 0 0 .5.8.8 0 0 0 0 .2v-.6m-.4 0-.9.6v.3l1-.7v-.2m-.8 0c-.1.2-.3.3-.5.3v.3c.2 0 .4-.1.5-.3v-.1a3.3 3.3 0 0 0 0-.1m-1-.3-.4.2v.2l.4-.2v-.2m3-.1.1.5a.8.8 0 0 0 0-.2v-.4.1m.4-.2.1.6a.4.4 0 0 0 0-.1v-.2a1 1 0 0 1 0-.3v-.2.2m.3 0 .1.3v-.1a.9.9 0 0 0 0-.5h-.1v.2m.4-.1a.8.8 0 0 1 .4.2v-.4a.8.8 0 0 0-.4-.2v.3m.3-.4.6.3v-.3a1.3 1.3 0 0 1-.6-.3v.4m.5-1.2h.4v-.2a2.5 2.5 0 0 0-.4 0v.2m-.3-.6.4-.4a5.7 5.7 0 0 0 0-.2l-.4.4v.2m-.4-.5a1 1 0 0 1 .2-.5v-.2a1.1 1.1 0 0 0-.2.6s0 .1 0 0m-.4-.2.5-.8v-.2l-.5.8v.2"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m254.4 208.3.1 1v-.1a.7.7 0 0 0 0-.2v-.8.1m-1.4.2.2.4a2 2 0 0 1 .1.3c0-.1 0 0 0 0v-.3l-.3-.6v.2m-.2.6a4.8 4.8 0 0 0-.6-.5 1.6 1.6 0 0 0 0 .1v.2l.6.4v-.2m.8.3a3 3 0 0 0-.1-1.8v.3c.2.4.2.8.1 1.2v.2m1.3-.7v-.3.3"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m253.6 209.4.1-1v-.3l-.2 1a1.6 1.6 0 0 0 0 .3m3.8 2.1c.3.1.6.3.7.6v-.4c-.1-.3-.4-.5-.7-.6v.4m-1 2v.6a1.2 1.2 0 0 0 0 .3s0 .1 0 0a2.8 2.8 0 0 0 0-1.2.7.7 0 0 0 0 .1v.3m-.9-.6v1.3s0 .2 0 0v-1.5.2m-.4.4a22.6 22.6 0 0 0-.3 1.7l.3-1.3v-.4m.6.3v1.1a1.5 1.5 0 0 0 0 .3c0 .1 0 .1 0 0v-1.6.2m-2.8.2a.7.7 0 0 1 0 .1v-.5.1a1.4 1.4 0 0 0 0 .3m1.2-.8.1.4v-.8.4m.3-.2a.4.4 0 0 1 .1.2s0 .1 0 0a.7.7 0 0 0 0 .2v-.3l-.1-.5a1.4 1.4 0 0 0 0 .2v.2m.4-.3.2.4a1 1 0 0 0 0-.2v-.2l-.2-.4a2.8 2.8 0 0 0 0 .3m.9-.3.5.7v-.4a10 10 0 0 1-.5-.7v.4m.4-.7.5.6v-.5a4.4 4.4 0 0 1-.4-.6v.5m-4.6-2.1a1.8 1.8 0 0 0-.5-.3v.4c.2 0 .3.2.5.3v-.4m1.4-.5a.5.5 0 0 1 0 .1v.1l.1-.2a1 1 0 0 0 0-.4 1 1 0 0 0 0 .1v.3m1-1.1-.1.8v.3s0 .1 0 0c.2-.3.2-.8.2-1.2a.6.6 0 0 0 0-.1v.2m.2 1.5.5-.6v-.4l-.5.6v.4m.7 0 .2-.3v-.3l-.2.2a1.4 1.4 0 0 0 0 .2v.2m1 .2a8.3 8.3 0 0 1-.7 0v.4a8 8 0 0 0 .8 0v-.4m-.3 1c.4.1.7.4 1 .6 0 0 .2-.4 0-.4l-1-.7v.4"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m256 211.2.9.6v-.5l-1-.6a2.3 2.3 0 0 0 0 .2v.2m-2-1.5v-.6.6m-2.4-1c.2.3.6.5 1 .8l.6.7s.1-.4 0-.4l-.6-.6-1-1c0 .1-.1.4 0 .4m.6 1.2a8.2 8.2 0 0 1-.5-.6 1.8 1.8 0 0 0 0 .2v.2a8 8 0 0 0 .5.6v-.4m-.4 2.7-.3.6v.4l.3-.6v-.4m.3.4v.7a1.4 1.4 0 0 0 0 .3v-1.1a.7.7 0 0 0 0 .1m1.1 2c.2-.8.2-1.4.2-2.1 0-.3 0 0 0 0 0 .6 0 1.1-.2 1.6v.4m.6-1.6.1.7a1.4 1.4 0 0 0 0 .3s0 .1 0 0v-1.4a.7.7 0 0 0 0 .2v.2m.6-.2c.2.3.3.6.2 1v.2c.1-.5.1-1.2-.2-1.6v.4"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m254.5 212.6.4 1.8v-.3a14.2 14.2 0 0 0-.3-1.9v.4m.5-.1.7 1.1a.7.7 0 0 0 0-.1v-.3a4 4 0 0 0-.7-1.1v.4m1.2-1c0-.2-.3-.3-.5-.2v.4c.2 0 .4 0 .5.2v-.4"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M255.7 211.3h1.2v-.5h-1.2v.5m.7-3.1a3 3 0 0 0-.5 1.3v.3s0 .1 0 0c0-.4.2-.9.5-1.2v-.4m-1.6.3c0 .4.2.7.3 1a.8.8 0 0 0 0-.1v-.3l-.3-1v.1a1.3 1.3 0 0 0 0 .3m-.3.6a1.6 1.6 0 0 1-.4-.5 1 1 0 0 0 0 .1v.3a1.7 1.7 0 0 0 .4.5v-.4m-.6.3c-.5-.1-.9-.3-1.3-.6v.4c.4.3.8.5 1.3.6v-.4"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    fill: "#dba05f",
    d: "m254.4 209.3-2.3.4-2 .2-1.3-.4c-.4 0-1.7-.2-2.2.3l-1 .8c-.1.2-.7.7-.7 1 0 .2.1.6.4.6.3 0 1 .6 1 .8 0 .2.8.4 1.6.4 1.4 0 2.1-.7 4.2-.4 1.2 0 3.3-.8 3.7-1.4.4-.5.6-1.1.2-1.7-.3-.7-1.5-.6-1.6-.6"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m254.4 209.3-2.3.4-2 .2-1.3-.4c-.4 0-1.7-.2-2.2.3l-1 .8c-.1.2-.7.7-.7 1 0 .2.1.6.4.6.3 0 1 .6 1 .8 0 .2.8.4 1.6.4 1.4 0 2.1-.7 4.2-.4 1.2 0 3.3-.8 3.7-1.4.4-.5.6-1.1.2-1.7-.3-.7-1.5-.6-1.6-.6z"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M246.8 211.3v-.1l.1-.2.2-.2a.9.9 0 0 1 .4-.3h-.1.7l-.7.1h.6-.5c-.3.1-.3.5-.7.7"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m246.7 211.2.4-.4.7-.3h.3"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m247.4 210.6-.4.3-.3.3m.8-.6h.5m-.6.1h.5"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "m247.9 211-.2.1-.1.1-.3.2-.4.1.5-.1-.4.1.4-.1-.4.1h.1s.4 0 .8-.4"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m247.8 211-.3.2s-.3.3-.4.2l-.2.1m.4-.1.3-.2.2-.2m-.4.4-.4.1m.4-.1-.3.1"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    fill: "#c6262c",
    d: "M248.4 209.6s0-.6-.6-.8a3.4 3.4 0 0 0-1.4-.2l-.6.1a2.7 2.7 0 0 0-.6.2v.3c-.2.2-.5.4-.4.6.2.3 0 .3.2.4.2 0 0-.1 0-.1s-1 .3-.8.9c.2.6.5.4.6.4l.5-.3.8-.7 1-.4h.6l.7-.4z"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M248.4 209.6s0-.6-.6-.8a3.4 3.4 0 0 0-1.4-.2l-.6.1a2.7 2.7 0 0 0-.6.2v.3c-.2.2-.5.4-.4.6.2.3 0 .3.2.4.2 0 0-.1 0-.1s-1 .3-.8.9c.2.6.5.4.6.4l.5-.3.8-.7 1-.4h.6l.7-.4z"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "m247.7 211-.3.4-.4-.1.4-.5.3.1"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9c0b9",
    d: "M243.8 213.6s-.7-1.3 1.4-2l.8.6s-.4.6-1.6.8c0 0-.6.2-.6.6"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M243.8 213.6s-.7-1.3 1.4-2l.8.6s-.4.6-1.6.8c0 0-.6.2-.6.6z"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9c0b9",
    d: "M244 213.4s.9.1 1.5-.3c.4-.3.6-.2.7-.1 0 0 0-.5-.2-.8l-1 .7c-.5 0-.8 0-1 .5"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M244 213.4s.9.1 1.5-.3c.4-.3.6-.2.7-.1 0 0 0-.5-.2-.8l-1 .7c-.5 0-.8 0-1 .5z"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    fill: "#7a2e26",
    d: "M246.4 213h.5v-.2h-.5v.1m-.3-2.2c-.1 0 0 .2-.2.3v.1c.1 0 0-.2.2-.2v-.2m.5.3.3-.2v-.1c-.2 0-.3 0-.4.2v.1m.6.8a.3.3 0 0 0 .3-.1v-.1a.3.3 0 0 1-.3 0v.2m.5-.2a.8.8 0 0 0 .4-.3v-.1a.8.8 0 0 1-.4.3v.1m-.7-.7-.4.4v.1l.4-.4v-.1m.3 2.2 1-.1v-.2a3.3 3.3 0 0 1-1 .2m1.6 0c.5-.3 1-.6 1-1.2v-.1c0 .6-.5.9-1 1.2v.1m.3-.8c.4-.2.6-.5.7-.9v-.1c-.1.4-.4.7-.7.9v.1m-.1-2c.2-.1.5.1.7.3v-.2l-.7-.3v.1m6.6 1c.3-.4.2-1-.1-1.4v.1c.2.4.4.8.1 1.2v.2m-5-.7c.2.2 1 .8.8 1.2v.1c.3-.6-.4-1.2-.9-1.5v.2m2.3 2.2a1.6 1.6 0 0 0 .1-.4.5.5 0 0 0 0-.1v.5"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e3f17",
    d: "m253.7 212.5.6-.3m-9-.2c-.4.2-1 .2-1 .7 0-.5.6-.5 1-.7"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    fill: "#842116",
    d: "M245 210.4c.1 0 .3.1.3.3a.5.5 0 0 0 0 .1.7.7 0 0 0 0-.3c0-.2-.2-.2-.3-.2v.1m.7.3a.7.7 0 0 0 0-.6v.6m.6-.6c0-.2-.1-.5-.4-.6v.1c.3.1.3.4.4.6a.3.3 0 0 0 0-.1m.5-.1c0-.2 0-.5-.2-.6v.1l.2.4m-.9-.7c.5-.2 1.6-.3 2 .2v-.2c-.4-.5-1.5-.4-2-.1v.1"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    fill: "#7a2e26",
    d: "M244.8 211.3v-.5s-.1 0 0 0v.5m5 1.5a.7.7 0 0 0 .3-.5v-.1a.7.7 0 0 1-.3.4v.2m.8-.1a.4.4 0 0 0 .1-.3l-.1.2v.1m4.6-2.5a1 1 0 0 1 .1.7.4.4 0 0 0 0 .1v-1s-.1.1 0 .2m-.6.4.1.7v-.8.1m-.5.4"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "m260.5 224.5.1.3h.1l-.1-.3z"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcddde",
    d: "M250 208c-1.7 0-3.5-1.2-3.5-1.2-2.3-.4-2.4-2.5-2.4-2.5-1-.3-1.7-2.6-1.7-2.6-1.4.8-3.2 0-3.2 0s0-.4-1.6 0c-1.6.3-1.3-.3-1.3-.3s.6-.7-2.2 0c-2.8.6.3-.9.3-.9-.9.3-3.5.5-3.5.5-1 0-2 .5-3 .8-.8.2-2 .4-2.5.7l-7.3 3.1-5.9 2.3c.3 0 3.7-2.3 8-4.2a93.5 93.5 0 0 1 11-4.2c3.1-1 5.6-.5 7 0 .7.2 4.4-.1 6 0 1.8.3 2 3 2 3 .2.2.4 2.8.4 2.8s-1 0 .1.2 3.1 1.7 3.1 1.7h.8s.4-.5.9-.7l1.6-.5h2.1l2.2.3c.9.1 1 .2 1.3.3h.5c1-.5 3.2-1.3 3.6-1.2 0 0 .8-.2 1.2-.5a112 112 0 0 0 1.4-1.1s-.6-4.7 4.1-4.3l12.3 1.3a47.8 47.8 0 0 1 12.5 4.5l4.3 1.9c2.4 1 4.1 2.5 4.1 2.5l-3.8-1.9c-1-.4-2-.6-2.8-1l-3.9-1.8c-3.7-1.7-3.6-1.8-5.1-1.9-1 0 .7 1.2.7 1.2l-4.4-1.7a6.3 6.3 0 0 0-3-.6 6.2 6.2 0 0 1-2.4-.3c-.6-.2-4-.4-4.7-.4a7.8 7.8 0 0 1-1-.2l.2.4-1.7-.3-.5.7s-1.6.3-1.7-.2c-.2-.5-1 2.4-1.4 3.2-.4.9-2.4.6-2.9 1.1-.4.6-1.5 1-1.7 1-.2.2-1 .1-1.4.1-.6 0 0 0-1.1.2l-1.2-.1-1.5-.5-3.8-.2a6 6 0 0 0-1.5.4l-1.3.8"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M250 208c-1.7 0-3.5-1.2-3.5-1.2-2.3-.4-2.4-2.5-2.4-2.5-1-.3-1.7-2.6-1.7-2.6-1.4.8-3.2 0-3.2 0s0-.4-1.6 0c-1.6.3-1.3-.3-1.3-.3s.6-.7-2.2 0c-2.8.6.3-.9.3-.9-.9.3-3.5.5-3.5.5-1 0-2 .5-3 .8-.8.2-2 .4-2.5.7l-7.3 3.1-5.9 2.3c.3 0 3.7-2.3 8-4.2a93.5 93.5 0 0 1 11-4.2c3.1-1 5.6-.5 7 0 .7.2 4.4-.1 6 0 1.8.3 2 3 2 3 .2.2.4 2.8.4 2.8s-1 0 .1.2 3.1 1.7 3.1 1.7h.8s.4-.5.9-.7l1.6-.5h2.1l2.2.3c.9.1 1 .2 1.3.3h.5c1-.5 3.2-1.3 3.6-1.2 0 0 .8-.2 1.2-.5l1.4-1.1s-.6-4.7 4.1-4.3l12.3 1.3a47.8 47.8 0 0 1 12.5 4.5l4.3 1.9c2.4 1 4.1 2.5 4.1 2.5l-3.8-1.9c-1-.4-2-.6-2.8-1l-3.9-1.8c-3.7-1.7-3.6-1.8-5.1-1.9-1 0 .7 1.2.7 1.2l-4.4-1.7a6.3 6.3 0 0 0-3-.6 6.2 6.2 0 0 1-2.4-.3c-.6-.2-4-.4-4.7-.4a7.8 7.8 0 0 1-1-.2l.2.4-1.7-.3-.5.7s-1.6.3-1.7-.2c-.2-.5-1 2.4-1.4 3.2-.4.9-2.4.6-2.9 1.1-.4.6-1.5 1-1.7 1-.2.2-1 .1-1.4.1-.6 0 0 0-1.1.2l-1.2-.1-1.5-.5-3.8-.2a6 6 0 0 0-1.5.4l-1.3.8"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    fill: "#452c25",
    d: "M250.3 207.4s-.2.1-.3.5v.2"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    fill: "#574f4c",
    d: "m259.5 206.9.7.5s0 .1 0 0a7 7 0 0 0-.8-.7.6.6 0 0 0 .1.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBo);
export default __webpack_public_path__ + "static/media/bo.b05a77cfd0991012bfd10cd15980ca60.svg";
export { ForwardRef as ReactComponent };